import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import './Widget.scss';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import 'react-input-range/lib/css/index.css';
import copy from 'copy-to-clipboard';
// import { toast } from 'react-toastify';
import toast from '../../components/Toastify';
import { Scrollbars } from 'react-custom-scrollbars';
import { confirmAlert } from 'react-confirm-alert';
import $ from 'jquery';
import { insta } from '../../img';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-sliding-side-panel/lib/index.css';
import SimpleReactValidator from 'simple-react-validator';
import Dropdown from 'react-dropdown';
import ContentLoader from 'react-content-loader';
import ReactTooltip from 'react-tooltip';
// import { Link } from 'react-router';s
import 'react-quill/dist/quill.snow.css';
// import 'react-datepicker/dist/react-datepicker.css';
import SlidingPanel from 'react-sliding-side-panel';

let userWidgetList;
let editType;

let currLayout = '';
let currCard = '';
let currPopup = '';
const regExp_youtube = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;

//containers
import { Integration } from '../index';//Plan
// import { Review } from '../index';//Plan

//components
import {
  Modal,
  DataSourceCard,
  LayoutCard,
  PostCard,
  AppearanceCard,
  PreviewCard,
  CreateWidgetCard,
  WidgetList,
  FilterCard,
  SettingCard,
  SchemaCard,
  PopupCard,
  ChatLayoutCard,
  ChatAppearanceCard,
  ChatDisplayRuleCard,
  ShopifyWidgetList,
  ToolLayoutCard,
  IconCard,
  GetCodeCard,
  CollectorLayoutCard,
  StoryWidgetDataCard,
  DataCollectCard,
  AutomationCard,
  AnalyticCard,
  WidgetHeader,
  InstafeedHeader,
  InstaFeedIntegration
} from 'components';

//ducks
import {
  createWidget,
  getWidgetByUser,
  getWidgetById,
  getWidgetData,
  getActiveIntgList,
  addDataSrc,
  delDataSrc,
  updWidgetCnf,
  updWidgetStatus,
  delUserWidget,
  getAnalytic,
  createHireUs,
  updWidgetName,
  redisCreateWidget,
  createCloneWidget,
  addShpWidgetDiv,
  getShpThemeList,
  deleteShpWidgetDiv,
  updWidgetIcon,
  getIconList,
  deleteIcon,
  onChangeUpdateWidget,
  onChangeSaveFilter,
  updSchemaValue
} from '../../ducks/widget';
import { getProfile } from '../../ducks/auth';
import { createInstaFeedURL, instaFeedPaymant } from '../../ducks/instaFeed.js';
import { getWidgetForInt, createCustomCollectorReview, deleteCustomCollectorReview } from '../../ducks/integration'; //getUsrIntegration
import { getThemeData } from '../../ducks/master';
import { DatasourceIntegration } from '../../components';

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: 'rgba(35, 49, 86, 0.8)'
  };
  return <div className="" style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = props => (
  <Scrollbars
    autoHide
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props} />
);

const optnPlatform = [
  { value: 'bigCommerce', label: 'BigCommerce' },
  { value: 'blogger', label: 'Blogger' },
  { value: 'duda', label: 'Duda' },
  { value: 'joomla', label: 'Joomla' },
  { value: 'opencart', label: 'Opencart' },
  { value: 'shopify', label: 'Shopify' },
  { value: 'squarespace', label: 'Squarespace' },
  { value: 'webnode', label: 'Webnode' },
  { value: 'wix', label: 'Wix' },
  { value: 'wordPress', label: 'WordPress' },
  { value: 'other', label: 'Other' },
];

//========= [S] create localstorage change dispatch event =============//
var orignalSetItem = localStorage.setItem;
localStorage.setItem = function (key, newValue) {
  var setItemEvent = new window.Event('setItemEvent');
  setItemEvent.key = key;
  setItemEvent.newValue = newValue;
  window.dispatchEvent(setItemEvent);
  orignalSetItem.apply(this, arguments);
};
//========= [E] create localstorage change dispatch event =============//
class Widget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabName: 'type',
      arrLylt: [],
      arrCard: [],
      arrPopup: [],
      currLayoutId: '',
      currCardId: '',
      currHtnpp: '',
      isEditWidget: false,
      _isCallTheme: true,
      cnf: {},
      cloneWidgetById: {},
      widgetById: {},
      colorPick: '',
      widgetList: [],
      newWidget: [],
      createdWidgetList: [],
      widgetListByUser: [],
      selectedWidgetList: [],
      selectedSource: '',
      selectedSourceImg: '',
      openCloseWidget: false,
      selectedWidget: '',
      wdsc: '',
      isMobileScreen: false,
      isOpenHireusModel: false,
      wurl: '',
      wplt: '',
      oth: '',
      he: '',
      rmk: '',
      isLoaderDS: false,//Loader for Datasource Page
      tabIndex: 0,
      intTabIndex: 0,
      excludeChips: '',
      includeChips: '',
      jobSkillChips: '',
      currCategory: '',
      isOpenGetCodeModel: false,
      isOpenPlanModel: false,
      objWidget: '',
      planWidget: '',
      cloneWid: '',
      cloneWn: '',
      openCloseCloneModal: false,
      widgetName: '',
      usedQuota: '-',
      assignQuota: 0,
      currWidgetMst: {},
      //for Shopify
      pgnm: 'all',
      pstn: 'top',
      thmid: '',
      thmnm: '',
      shpToken: '',
      openCloseIconModel: false,
      ThemeOption: [],
      //chat widget
      dt: '2',
      ul: '',
      utmCnd: '0',
      utmTxt: '',
      ckeCnd: '0',
      ckeTxt: '',
      refCnd: '2',
      refTxt: '',
      iconType: '',
      iconstate: '',
      iconchildState: '',
      iconUrl: '',
      iconLabel: '',
      isLoadIcon: false, //for show loader in icon model 
      isLoadIconscout: false,
      iconscout: '',
      arrIconscout: [],
      createWidgetIndex: 0,
      dmyWdIndex: 0,
      openCloseStoryData: false,
      objStoryData: {},
      isPlnPurchase: false,
      frmdtintnm: '',
      arrName: '',
      lstActiveIntg: [],
      WidgetListIndex: 0,
      isOpenAnalyticModel: false,
      src: '',
      selectedTab: 'all',
      selectWidget: '',
      getCodeTabName: 'javascript',
      arrWidgetDt: [],
      arrWidgetCnt: [],
      ttlImpcnt: 0,
      isEdit: false,
      isOpenIntegrationModel: false,
      compIntegration: '',//After auth open specific integration
      isOpenViewReviewModel: false,
      usIntObj: {},
      isFiltered: false,
      _scmathr: '',
      _scmcmpnm: '',
      _scmctgry: '',
      _scmdsc: '',
      scmimgurl: '',
      instaLoad: false,
      paymantPopup: false,
      isOpenInstaFeedModel: false,
    };
    this.authToken = ''; try { this.authToken = localStorage.getItem('authToken'); } catch (e) {/** error */ }
    this.hireValidator = new SimpleReactValidator();
    this.postCardValidator = new SimpleReactValidator();
    this.cloneWidgetValidator = new SimpleReactValidator();
    this.DisplayValidator = new SimpleReactValidator();
    this.DisplayUTMValidator = new SimpleReactValidator();
    this.cookieValidator = new SimpleReactValidator();
    this.ReferralValidator = new SimpleReactValidator();
    this.iconValidator = new SimpleReactValidator();
    this.widgetDataValidator = new SimpleReactValidator();
  }
  componentDidMount = () => {
    // this.state.WidgetListIndex = 0;
    this.state.createWidgetIndex = 0;

    let self = this;
    window.addEventListener('setItemEvent', function (e) {
      if (e.key == 'W_TBINT' && e.newValue) {
        self.state.tabName = 'dataSource';
        self.state.tabIndex = 4;
        self.setState(self.state);
      }
    });

    window.onbeforeunload = function () {
      if (this.authToken && this.state.isEditWidget && !localStorage.getItem('W_WDGT_CRT')) {
        return '';
      }
    }.bind(this);

    if (!this.props.themeData) {
      this.props.getThemeData();
    }

    if (!this.props.userWidget && this.authToken) {
      let obj = {
        wid: localStorage.getItem('WIDTP'),
        pvd: localStorage.getItem('pvd')
      };
      this.props.getWidgetByUser(obj);
    }

    //when user click add widget btn from another page without page refresh 
    if (this.props.themeData) {
      this.filterWidgetList('all');

      //for shopify user get current Widget type
      if (localStorage.getItem('pvd') == 'shopify' && localStorage.getItem('WIDTP')) {
        this.state.currWidgetMst = this.props.themeData.widget.filter(x => x._id == localStorage.getItem('WIDTP'))[0];
      }
    }

    // if user login, and in edit widget section page refresh then call this api.
    if (this.props.location.query.id) {
      localStorage.setItem('W_FOR_MASONRY', 'widget_repons');
      this.props.getWidgetById(this.props.location.query.id);
      let obj = {
        wallId: this.props.location.query.id,
        cn: this.props.location.query.cn
      };
      this.props.getWidgetData(obj);
      setTimeout(() => {
        localStorage.removeItem('W_FOR_MASONRY');
      }, 2000);
    }

    let that = this;
    $('body').click(function (e) {
      if (e.target.id !== 'color_code' && $(e.target).parents('#color_code').length == 0) {
        if (Object.keys(that.state.colorPick).length > 0) {
          that.state.colorPick = {};
          that.setState(that.state);
        }
      }
    });

    localStorage.removeItem('W_RESPONSIVE');
    localStorage.removeItem('W_IS_RENDER');
    //on page refresh clear feed slide index
    localStorage.removeItem('W_FEED_SLIDE');
    //for get the latest widget for integration
    if (this.authToken) {
      this.props.getWidgetForInt();
    }

    //for get the user created integration list
    // if (this.authToken && !this.props.lstUsrInt) {
    //   this.props.getUsrIntegration();
    // }

    //after create integration redirect the data source tab
    // if (this.authToken && this.props.location.query.tb) {
    //   this.state.tabIndex = 4;
    //   this.setState(this.state);
    // }
    //
    const wdtnm = this.props.location.query.wdtnm;
    if (wdtnm == 'back_to_top') {
      this.state.iconscout = 'top';
    } else {
      this.state.iconscout = '';
    }
    this.setState(this.state);
    this.searchIconscout();
  }

  componentDidUpdate = (prevprops) => {
    this.state.getCodeTabName = 'javascript';
    // this.state.WidgetListIndex = 0;
    this.state.createWidgetIndex = 0;
    //if user login then call api otherwise not.
    if (this.authToken && this.state.tabName == 'type') {//this.props.location.query.id &&
      this.state.tabName = 'dataSource';
      this.props.getActiveIntgList();
    }

    //in edit theme section on page refresh get theme list    
    if (this.props.location.query.wid && prevprops.themeData !== this.props.themeData) {
      //common function for get the current widget supported theme list
      this.fnGetLayoutList(this.props.location.query.wid, this.props.location.query.cn);
      //for get theme data from the wid
      this.getWidgetFrmWid(this.props.location.query.wid);
    }
    //after integration authentication complete then open specific integration with side panel
    if (this.props.location && this.props.location.query && this.props.location.query.intds && this.props.lstActiveIntg) {
      this.state.compIntegration = this.props.location.query.intds;
      this.state.isOpenIntegrationModel = true;
      this.setState(this.state);
    }
    // open widget limit popup
    if (prevprops.activeStatus !== this.props.activeStatus) {
      let _i = this.props.userWidget.findIndex(x => x._id == this.props.activeStatus._id);
      if (_i !== -1) {
        this.props.userWidget[_i].ia = false;
        this.props.userWidget[_i].udt = new Date();
        toast.error('Free Plan is limited to only 1 active Wall. Upgrade now');
      }
      this.setState(this.state);
    }

    //when user click add widget btn after the page refresh
    // if (this.props.location.query.ds === 'type' && prevprops.themeData !== this.props.themeData) {
    //   this.filterWidgetList('all');
    // }

    if (prevprops.widgetById !== this.props.widgetById && this.props.widgetById) {
      this.state._scmathr = this.props.widgetById.scmathr;
      this.state._scmcmpnm = this.props.widgetById.scmcmpnm;
      this.state._scmctgry = this.props.widgetById.scmctgry;
      this.state._scmdsc = this.props.widgetById.scmdsc;
      this.state._scmimgurl = this.props.widgetById.scmimgurl;
      this.setState(this.state);
    }
  }

  componentWillReceiveProps = (nextprops) => {
    this.state.getCodeTabName = 'javascript';
    this.state.widgetName = '';
    // this.state.WidgetListIndex = 0;
    this.state.createWidgetIndex = 0;
    if (localStorage.getItem('wmid')) {
      this.state.isPlnPurchase = true;
      this.setState(this.state);
      localStorage.removeItem('wmid');
    }

    setTimeout(() => {
      if (this.props.location.pathname == '/widget/') {
        if (document.getElementById('sidebarlink_1')) {
          document.getElementById('sidebarlink_1').classList.add('side-active');
        }
      }
      else if (this.props.location.query.ds == 'type') {
        this.state.createWidgetIndex = 0;
        if (document.getElementById('add_wall_btn')) {
          document.getElementById('add_wall_btn').style.display = 'none';
        }
        if (document.getElementById('sidebarlink_0'))
          document.getElementById('sidebarlink_0').classList.add('side-active');

        if (document.getElementById('side-menu'))
          document.getElementById('side-menu').style.display = 'block';

        if (document.getElementById('main-div'))
          document.getElementById('main-div').style.width = 'calc(100% - 106px)';
      }
      else if (this.props.location.query.ds == 'list') {
        // this.state.WidgetListIndex = 0;
        if (document.getElementById('main-div'))
          document.getElementById('main-div').style.width = 'calc(98% - 90px)';

        if (document.getElementById('add_wall_btn')) {
          document.getElementById('add_wall_btn').style.display = 'flex';
        }
        if (document.getElementById('sidebarlink_0'))
          document.getElementById('sidebarlink_0').classList.remove('side-active');

        if (document.getElementById('sidebarlink_1'))
          document.getElementById('sidebarlink_1').classList.add('side-active');
      }


      if (!this.props.location.query.wid) {
        this.hideShowSidePanel('show');
      } else {
        this.hideShowSidePanel('hide');
      }
    }, 100);

    // if (nextprops.userWidget && nextprops.userWidget.length > 0 && nextprops.themeData) {
    if (nextprops.userWidget) {
      if (nextprops.userWidget.length > 0 && nextprops.themeData) {
        this.state.widgetListByUser = [];
        this.state.widgetListByUser = nextprops.userWidget;
        userWidgetList = [];
        nextprops.userWidget.filter(u => {
          nextprops.themeData.widget.filter(w => {
            if (u.wid == w._id) {
              let _index = userWidgetList.findIndex(x => x._id == w._id);
              if (_index == -1)
                userWidgetList.push(w);
            }
          });
        });
        //get active deactive count function
        if (this.state.widgetListByUser.length > 0 && userWidgetList && userWidgetList.length > 0) {
          this.getWidgetStatusCount();
          //open last edited widget list in sidebar
          if (editType != '') {
            let _i = userWidgetList.findIndex(x => x.wn == editType);
            if (_i !== -1) {
              setTimeout(() => {
                this.openCloseWidgetPanel(userWidgetList[_i]);
              }, 100);
            }
            editType = '';
          }
        }
        this.state.isFiltered = true;
      }
      else {
        if (nextprops.themeData) {
          this.state.isFiltered = true;
          userWidgetList = [];
        }
      }
      this.setState(this.state);
    }

    //filter theme list by category 
    if (nextprops.themeData && nextprops.themeData.widget.length > 0) {
      // this.state.newWidget = [];
      this.state.widgetList = nextprops.themeData.widget;
      this.state.newWidget = nextprops.themeData.widget;

      //for shopify user get current Widget type
      if (localStorage.getItem('pvd') == 'shopify' && localStorage.getItem('WIDTP')) {
        this.state.currWidgetMst = nextprops.themeData.widget.filter(x => x._id == localStorage.getItem('WIDTP'))[0];
      }
      this.setState(this.state);
    }

    //When the user is logged in, and edit the widget, then assign theme data from the created widget   
    if (nextprops && nextprops.widgetById && nextprops.widgetById !== this.props.widgetById) {
      const params = (new URL(window.location)).searchParams;
      //clone wall object
      if (this.authToken && localStorage.getItem('W_WDGT_CRT')) {
        let obj = JSON.parse(localStorage.getItem('W_WDGT_CRT'));
        this.state.cloneWidgetById = JSON.stringify(obj.widgetById);
        this.state.widgetById = obj.widgetById;
        this.state.wdsc = obj.wdsc;
        this.state.isEditWidget = obj.isEditWidget;
        let paramInt = params.get('intds');
        let URi = process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?wid=' + obj.widgetById.wid + '&id=' + obj.widgetById._id + '&cn=' + obj.widgetById.cn + '&wdtnm=' + obj.widgetById.wdtnm;
        if (paramInt) {
          URi = process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?wid=' + obj.widgetById.wid + '&id=' + obj.widgetById._id + '&cn=' + obj.widgetById.cn + '&wdtnm=' + obj.widgetById.wdtnm + '&intds=' + paramInt;
        }
        browserHistory.push(URi);
      }
      else {
        this.state.cloneWidgetById = JSON.stringify(nextprops.widgetById);
        this.state.widgetById = nextprops.widgetById;
        // if (this.props.widgetById) {
        //   this.state.widgetById.scmathr = this.props.widgetById.scmathr;
        //   this.state.widgetById.scmcmpnm = this.props.widgetById.scmcmpnm;
        //   this.state.widgetById.scmctgry = this.props.widgetById.scmctgry;
        //   this.state.widgetById.scmdsc = this.props.widgetById.scmdsc;
        //   this.state.widgetById.scmimgurl = this.props.widgetById.scmimgurl;
        // }
        // else {
        //   this.state.widgetById.scmathr = nextprops.widgetById.scmathr;
        //   this.state.widgetById.scmcmpnm = nextprops.widgetById.scmcmpnm;
        //   this.state.widgetById.scmctgry = nextprops.widgetById.scmctgry;
        //   this.state.widgetById.scmdsc = nextprops.widgetById.scmdsc;
        //   this.state.widgetById.scmimgurl = nextprops.widgetById.scmimgurl;
        // }
        this.state.wdsc = nextprops.widgetById.wdsc;
        let paramInt = params.get('intds');
        let URi = process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?wid=' + nextprops.widgetById.wid + '&id=' + nextprops.widgetById._id + '&cn=' + nextprops.widgetById.cn + '&wdtnm=' + nextprops.widgetById.wdtnm;
        if (paramInt) {
          URi = process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?wid=' + nextprops.widgetById.wid + '&id=' + nextprops.widgetById._id + '&cn=' + nextprops.widgetById.cn + '&wdtnm=' + nextprops.widgetById.wdtnm + '&intds=' + paramInt;
        }
        browserHistory.push(URi);
        this.fnGetLayoutList(nextprops.widgetById.wid, nextprops.widgetById.cn);
      }
      this.state.currLayoutId = this.state.widgetById.htn;
      this.state.currCardId = this.state.widgetById.htncrd;
      this.state.currHtnpp = this.state.widgetById.htnpp;
      this.state.cnf = this.state.widgetById.cnf;
      this.setState(this.state);

      // // this.editorBackground();
      // this.fnGetLayoutList(this.props.location.query.wid, this.props.location.query.cn);
    }


    if (nextprops && nextprops.themeData && nextprops.widgetById && this.props.location.query.wid == nextprops.widgetById.wid && this.state._isCallTheme) {
      this.state._isCallTheme = false;
      this.setState(this.state);
      //get current layout supported card list
      this.fnGetCardAndPopupList(nextprops.widgetById.htn, nextprops.themeData);
    }

    //for analytics
    if (nextprops && nextprops.analytic !== this.props.analytic) {
      this.state.arrWidgetDt = [];
      this.state.arrWidgetCnt = [];
      this.state.ttlImpcnt = 0;
      for (let i = 0; i < nextprops.analytic.length; i++) {
        let obj = nextprops.analytic[i];
        this.state.ttlImpcnt += obj.uqv;
        this.state.arrWidgetDt.push(obj.dt);
        this.state.arrWidgetCnt.push(obj.uqv);
      }
      this.setState(this.state);
    }

    //for shopify user get quota uses 
    if (this.state.currWidgetMst && nextprops.profile && nextprops.profile.arpln && this.state.usedQuota == '-') {
      this.state.usedQuota = 0;
      this.state.assignQuota = 0;

      nextprops.profile.arpln.filter(x => {
        if (x.wmid == this.state.currWidgetMst._id) {
          this.state.usedQuota = x.uuq;
          this.state.assignQuota = x.uaq;
        }
      });
      this.setState(this.state);
    }

    if (this.props.profile != nextprops.profile) {
      //for normal user on click Quota refresh btn get latest data
      if (this.state.selectedWidget) {
        nextprops.profile.arpln.filter(x => {
          if (x.wmid == this.state.selectedWidget._id) {
            this.state.usedQuota = x.uuq;
            this.state.assignQuota = x.uaq;
          }
        });
      }

      //get the theme option for shopify user
      if (nextprops.profile.arpln && localStorage.getItem('WIDSHP')) {
        let objPln = nextprops.profile.arpln.filter(x => x.shp == localStorage.getItem('WIDSHP'))[0];
        if (objPln) {
          this.state.ThemeOption = [];
          this.state.shpToken = objPln.access_token;
          for (let i = 0; i < objPln.theme.length; i++) {
            const theme = objPln.theme[i];
            if (theme.role == 'main') {
              this.state.thmid = theme.id;
              this.state.thmnm = theme.name;
            }

            let role = theme.role == 'main' ? ' (Current)' : '';
            let label = theme.name + role;
            this.state.ThemeOption.push({ value: theme.id.toString(), label: label });
          }
        }
      }
      this.state.he = nextprops.profile.e;
      this.setState(this.state);
    }

    //on click install widget btn, get All shopify install div list 
    if (this.props.lstWidgetDiv != nextprops.lstWidgetDiv) {
      if (this.state.objWidget) {
        let wid = this.state.objWidget._id;
        let userWidget = this.state.widgetListByUser;
        for (let i = 0; i < userWidget.length; i++) {
          if (userWidget[i]._id == wid) {
            userWidget[i].shfyatinstlarr = nextprops.lstWidgetDiv.shfyatinstlarr;
          }
        }
      }
      this.setState(this.state);
    }

    //for icon modal loader
    if (nextprops.iconList !== this.props.iconList) {
      this.state.isLoadIcon = false;
      this.setState(this.state);
    }

    if ((nextprops.lstActiveIntg && nextprops.lstActiveIntg) !== (this.props.lstActiveIntg && this.props.lstActiveIntg)) {
      this.state.lstActiveIntg = nextprops.lstActiveIntg;
      this.setState(this.state);
    }

    if (nextprops.instaFeedURL !== this.props.instaFeedURL && this.state.instaLoad == false) {
      this.state.instaLoad = true;
      this.setState(this.state);
      // window.open(nextprops.instaFeedURL.url, '_self');
      window.parent.location.href = nextprops.instaFeedURL.url;
    }

    if (nextprops.instaFeedUser && nextprops.instaFeedUser !== this.props.instaFeedUser && this.state.paymantPopup == false) {
      if (nextprops.instaFeedUser.bobj == undefined || nextprops.instaFeedUser.bobj == null || !nextprops.instaFeedUser.bobj) {
        this.state.paymantPopup = true;
        this.state.isOpenInstaFeedModel = true;
        this.setState(this.state);
      }
    }
  }

  /***********************Create Widget***********************/
  //common function for check, user puchase plan for this widget
  fnChkWidgetPlan = (wid, objUser) => {
    //check user plan purchased or not
    this.state.isPlnPurchase = false;
    // if (objUser && objUser.imstpln) {
    //   this.state.isPlnPurchase = true;
    // }
    // else
    if (objUser && objUser.arpln != undefined) {
      objUser.arpln.filter(x => {
        let chkDt = new Date(x.expdt).getTime() >= new Date().getTime();
        if (chkDt) {
          if (x.imst == true) {
            this.state.isPlnPurchase = true;
          } else if (x.wmid == wid) { //&& x.uaq > x.uuq
            this.state.isPlnPurchase = true;
          }
        }
      });
    }
    this.setState(this.state);
  }

  filterWidgetList = (type) => {
    let _arr = [];
    if (type == 'all') {
      _arr = this.props.themeData.widget;
      if (this.state.src !== '') {
        _arr = this.searchWidget();
      }
      this.state.widgetList = _arr;
    }
    else {
      if (this.state.src !== '') {
        let widgetAry = this.searchWidget();
        widgetAry && widgetAry.filter(x => {
          if (x.cn == type) {
            _arr.push(x);
          }
        });
      }
      else {
        this.props.themeData && this.props.themeData.widget.filter(x => {
          if (x.cn == type) {
            _arr.push(x);
          }
        });
      }
      this.state.widgetList = _arr;
    }
    this.state.selectedTab = type;
    this.setState(this.state);
  }

  //function for serach widget by name
  searchWidget = () => {
    let str = new RegExp(this.state.src);
    let dataAry = [];
    for (let i = 0; i < this.props.themeData.widget.length; i++) {
      if (str.test(this.props.themeData.widget[i].dn.toLowerCase())) {
        dataAry.push(this.props.themeData.widget[i]);
      }
    }
    return dataAry;
  }

  searchWidgetHandle = (value) => {
    if (value) {
      this.state.src = value;
      this.state.widgetList = this.searchWidget();
      this.setState(this.state);
    }
    else {
      this.state.src = '';
      this.filterWidgetList(this.state.selectedTab);
      this.setState(this.state);
    }
  }

  //
  handleCreateWidgetTabChange = (index) => {
    this.state.createWidgetIndex = index;
    this.state.dmyWdIndex = '';
    this.setState(this.state);
  }

  //
  rdtCreateWidget = () => {
    this.state.dmyWdIndex = this.state.WidgetListIndex;
    browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=type');
    this.setState(this.state);
  }

  // rdtPurchasePlan = () => {
  //   browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX +'plan?wn=' + this.props.location.query.wdtnm + '&wmid=' + this.props.location.query.wid);
  // }

  //in create new widget section, onclick widget redirect the edit widget section
  rdtEditWidget = (obj) => {
    //just a falg for update the localStorage
    localStorage.setItem('W_FOR_MASONRY', 'widget_repons');
    browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?wid=' + obj._id + '&cn=' + obj.cn + '&wdtnm=' + obj.wn);
    //for get widget data from the wid
    this.getWidgetFrmWid(obj._id);
    //common function for get the current widget supported layout list
    this.fnGetLayoutList(obj._id, obj.cn);

    //on create new widget clear the old widget data in local storage
    localStorage.removeItem('W_WDGT_CRT');

    //remove falg for update the localStorage
    setTimeout(() => {
      localStorage.removeItem('W_FOR_MASONRY');
    }, 2000);

    if (obj.wn == 'back_to_top') {
      this.state.iconscout = 'top';
    }
    this.state.tabIndex = 0;
    this.setState(this.state);
    this.searchIconscout();
    this.createWidget();
  }

  //When the user create the widget, then assign default theme from widget master
  //for get theme data from the wid
  getWidgetFrmWid = (wid) => {
    if (!this.props.location.query.id) { //&& this.props.location.query.wid      
      //if user login and refresh the page
      if (this.authToken && localStorage.getItem('W_WDGT_CRT')) {
        let obj = JSON.parse(localStorage.getItem('W_WDGT_CRT'));
        this.state.cloneWidgetById = JSON.stringify(obj.widgetById);
        this.state.wdsc = obj.wdsc;
        this.state.widgetById = obj.widgetById;
        this.state.currLayoutId = obj.currLayoutId;
        obj.currCardId ? this.state.currCardId = obj.currCardId : '';
        obj.currHtnpp ? this.state.currHtnpp = obj.currHtnpp : '';
        this.state.cnf = this.state.widgetById.cnf;
        this.state.isEditWidget = obj.isEditWidget;
      } else {
        //get the first theme id in widget list 
        let obj = this.props.themeData.widget.filter(x => x._id == wid)[0];
        let objWid = JSON.stringify(obj);
        objWid = JSON.parse(objWid);
        this.state.wdsc = objWid.dn;
        let objWidget = objWid.config;
        objWidget.wdtnm = objWid.wn;
        objWidget.htn = objWid.htn;
        objWid.htncrd ? objWidget.htncrd = objWid.htncrd : '';
        objWid.htnpp ? objWidget.htnpp = objWid.htnpp : '';
        objWidget.cn = objWid.cn;
        objWidget.wid = wid;
        objWidget.dsi = [];
        this.state.cloneWidgetById = JSON.stringify(objWidget);
        this.state.widgetById = objWidget;
        this.state.currLayoutId = objWid.htn;
        objWid.htncrd ? this.state.currCardId = objWid.htncrd : '';
        objWid.htnpp ? this.state.currHtnpp = objWid.htnpp : '';
        this.state.cnf = objWidget.cnf;
      }

      //for countdown timer 
      if (this.state.cnf && this.state.cnf.tlstmdr != undefined) {
        this.state.cnf.tlstmdr = new Date().setDate(new Date().getDate() + 1);
      }
      this.state.isEditWidget = true;
      this.setState(this.state);
      //get current layout supported card list
      this.fnGetCardAndPopupList(this.state.currLayoutId, this.props.themeData);

      // this.editorBackground();
    }
  }

  //when user not login and create widget
  wdtLoginCreateWidget = () => {
    let obj = this.state.widgetById;
    obj.cnf = this.state.cnf;
    obj.wdsc = this.state.wdsc;
    this.props.redisCreateWidget(obj);
  }

  //common function for store input value in state
  handleInputchange = (state, value) => {
    if (state == 'thmid') { //for shopify
      this.state.thmid = value.value;
      this.state.thmnm = value.label.replace('(Current)', '');
    } else {
      this.state[state] = value;
    }

    if (state == 'wdsc') {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
  }

  //on change save widget
  onChangeUpdateWidget = (type) => {
    let that = this;
    // if (type == 'dspltyp') {
    //   obj = {
    //     widgetId: this.props.location.query.id,
    //     dspltyp: value
    //   };
    //   this.props.onChangeUpdateWidget(obj);
    // }else
    // if (type == 'dabs') {
    //   obj = {
    //     widgetId: this.props.location.query.id,
    //     dabs: value
    //   };
    //   this.props.onChangeUpdateWidget(obj);
    // }
    // else
    if (type == 'dsplurl') {
      if (!that.DisplayValidator.allValid()) {
        that.DisplayValidator.showMessages();
        that.forceUpdate();
      }
      else {
        let _arrDsplUrl = this.state.widgetById.dsplurl ? this.state.widgetById.dsplurl : [];
        let _arr = {
          ul: this.state.ul,
          dt: this.state.dt
        };
        _arrDsplUrl.push(_arr);

        this.state.widgetById.dsplurl = _arrDsplUrl;
        // obj = {
        //   widgetId: this.props.location.query.id,
        //   dsplurl: _arrDsplUrl
        // };
        // this.props.onChangeUpdateWidget(obj);
        this.state.ul = '';
        this.state.dt = '2';
        this.setState(this.state);
      }
    }
    // else if (type == 'irtnvstr') {
    //   obj = {
    //     widgetId: this.props.location.query.id,
    //     irtnvstr: value
    //   };
    //   this.props.onChangeUpdateWidget(obj);
    // } else
    // if (type == 'rtncnd') {
    //   obj = {
    //     widgetId: this.props.location.query.id,
    //     rtncnd: value
    //   };
    //   this.props.onChangeUpdateWidget(obj);
    // } else 
    // if (type == 'iutmdspl') {
    //   obj = {
    //     widgetId: this.props.location.query.id,
    //     iutmdspl: value
    //   };
    //   this.props.onChangeUpdateWidget(obj);
    // } else
    if (type == 'utmcnd') {
      if (!that.DisplayUTMValidator.allValid()) {
        that.DisplayUTMValidator.showMessages();
        that.forceUpdate();
      }
      else {
        let _arrUtmUrl = this.state.widgetById.utmcnd ? this.state.widgetById.utmcnd : [];
        let _arr = {
          cnd: this.state.utmCnd,
          txt: this.state.utmTxt
        };
        _arrUtmUrl.push(_arr);
        this.state.widgetById.utmcnd = _arrUtmUrl;

        // obj = {
        //   widgetId: this.props.location.query.id,
        //   utmcnd: _arrUtmUrl
        // };
        // this.props.onChangeUpdateWidget(obj);        
        this.state.utmCnd = '0';
        this.state.utmTxt = '';
        this.setState(this.state);
      }
    }
    // else if (type == 'ibcks') {
    //   obj = {
    //     widgetId: this.props.location.query.id,
    //     ibcks: value
    //   };
    //   this.props.onChangeUpdateWidget(obj);
    // } else 
    if (type == 'bckscnd') {
      if (!that.cookieValidator.allValid()) {
        that.cookieValidator.showMessages();
        that.forceUpdate();
      }
      else {
        let _arrCksCnd = this.state.widgetById.bckscnd ? this.state.widgetById.bckscnd : [];
        let _arr = {
          cnd: this.state.ckeCnd,
          txt: this.state.ckeTxt
        };
        _arrCksCnd.push(_arr);
        this.state.widgetById.bckscnd = _arrCksCnd;

        // obj = {
        //   widgetId: this.props.location.query.id,
        //   bckscnd: _arrCksCnd
        // };
        // this.props.onChangeUpdateWidget(obj);
        this.state.ckeCnd = '0';
        this.state.ckeTxt = '';
        this.setState(this.state);
      }
    }
    // else if (type == 'irffrm') {
    //   obj = {
    //     widgetId: this.props.location.query.id,
    //     irffrm: value
    //   };
    //   this.props.onChangeUpdateWidget(obj);
    // } else
    if (type == 'rfcnd') {
      if (!that.ReferralValidator.allValid()) {
        that.ReferralValidator.showMessages();
        that.forceUpdate();
      }
      else {
        let _arrRefCnd = this.state.widgetById.rfcnd ? this.state.widgetById.rfcnd : [];
        let _arr = {
          cnd: this.state.refCnd,
          txt: this.state.refTxt
        };
        _arrRefCnd.push(_arr);
        this.state.widgetById.rfcnd = _arrRefCnd;

        // obj = {
        //   widgetId: this.props.location.query.id,
        //   rfcnd: _arrRefCnd
        // };
        // this.props.onChangeUpdateWidget(obj);
        this.state.refCnd = '2';
        this.state.refTxt = '';
        this.setState(this.state);
      }
    }

    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
  }

  //common function for Remove display rules
  removeDisplayRule = (type, id) => {
    let _arr = this.state.widgetById[type];
    if (_arr.length > 0) {
      for (let i = 0; i < _arr.length; i++) {
        if (_arr[i]._id == id) {
          _arr.splice(i, 1);
        }
      }
      this.state.widgetById[type] = _arr;
      // let obj = {
      //   widgetId: this.props.location.query.id,
      //   [type]: _arr
      // };
      // this.props.onChangeUpdateWidget(obj);
      this.setState(this.state);
      if (!this.state.isEditWidget) {
        this.state.isEditWidget = true;
      }
    }
  }

  //when user login and create widget
  createWidget = () => {
    this.state.isEditWidget = false;
    let obj = this.state.widgetById;
    obj.cnf = this.state.cnf;
    obj.wdsc = this.state.wdsc;
    obj.htn = this.state.currLayoutId;
    obj.htncrd = this.state.currCardId;
    obj.htnpp = this.state.currHtnpp;
    obj.pvd = localStorage.getItem('pvd');
    obj.addonqty = this.props.profile.addonqty;
    //remove old widgetList after create new widget
    this.state.widgetListByUser = [];
    this.setState(this.state);
    this.props.createWidget(obj);
    //on create new widget clear the old widget data in local storage
    localStorage.removeItem('W_WDGT_CRT');
  }

  //store the create widget data in local storage 
  // storeWigetData = () => {
  //   let obj = this.state.widgetById;
  //   obj.cnf = this.state.cnf;
  //   obj.wdsc = this.state.wdsc;
  //   this.setState(this.state);
  //   if (!this.props.location.query.id) {
  //     localStorage.setItem('W_WDGT_CRT', JSON.stringify(obj));
  //   } else {
  //     localStorage.setItem('W_WDGT_UPD', JSON.stringify(obj));
  //   }
  // }

  //common function for hide show the side panel 
  hideShowSidePanel = (type) => {
    if (type == 'hide') {
      if (document.getElementById('side-menu'))
        document.getElementById('side-menu').style.display = 'none';


      if (document.getElementById('main-div'))
        document.getElementById('main-div').style.width = '100%';
    }
    else {
      if (document.getElementById('side-menu'))
        document.getElementById('side-menu').style.display = 'block';

      if (document.getElementById('main-div'))
        document.getElementById('main-div').style.width = 'calc(100% - 106px)';

      //clear local storage when exit from the edit section
      localStorage.removeItem('W_THEME_TYPE');
      localStorage.removeItem('W_DSBRD_CNFG');
      localStorage.removeItem('W_RENDER');
      localStorage.removeItem('W_DSBRD_DATA');
      localStorage.removeItem('W_DSBRD_SINGL');
    }
  }

  /***********************data-source**********************/
  //for review collector widget 
  createCustomCollectorReview = () => {
    let obj = {
      id: this.props.location.query.id,
      rmk: this.state.frmdtintnm
    };
    this.props.createCustomCollectorReview(obj);

    //set in widgetById state
    this.state.widgetById.frmdtintnm = this.state.frmdtintnm;
    this.setState(this.state);
  }

  deleteCustomCollectorReview = () => {
    this.props.deleteCustomCollectorReview(this.props.location.query.id);
    //remove in widgetById state
    this.state.widgetById.frmdtintnm = '';
    this.setState(this.state);
  }

  selectDataSrc = (obj) => {
    this.state.selectedSource = obj.in;
    this.state.selectedSourceName = obj.dn;
    this.state.selectedSourceImg = obj.img;
    this.setState(this.state);
  }

  displayDataSrc = () => {
    this.state.selectedSource = '';
    this.state.selectedSourceName = '';
    this.state.selectedSourceImg = '';
    this.setState(this.state);
  }

  handleDataSource = (id, pid, chkBox, objCountParams, objInt) => {
    localStorage.setItem('W_LOAD_DS_DATA', true);
    if (this.props.location.query.id) {
      let obj = {
        uid: id,
        _id: this.props.location.query.id,
        cn: this.props.location.query.cn,
        pgrtngavg: chkBox == true && objCountParams.pgrtngavg ? objCountParams.pgrtngavg : 0,
        pglkcnt: chkBox == true && objCountParams.pglkcnt ? objCountParams.pglkcnt : 0,
        pgflcnt: chkBox == true && objCountParams.pgflcnt ? objCountParams.pgflcnt : 0,
        pgrtngcnt: chkBox == true && objCountParams.pgrtngcnt ? objCountParams.pgrtngcnt : 0,
        pu: chkBox == true && objCountParams.pu ? objCountParams.pu : '',
        iin: objCountParams.iin ? objCountParams.iin : '',
        rmk: objCountParams.rmk ? objCountParams.rmk : '',
        url: chkBox == true && objCountParams.url ? objCountParams.url : '',
        dn: chkBox == true && objCountParams.dn ? objCountParams.dn : '',
        isFromInt: chkBox == true && objCountParams.isFromInt ? objCountParams.isFromInt : '',
        itwtpst: chkBox == true && objCountParams.itwtpst ? objCountParams.itwtpst : '',
        itwtrpls: chkBox == true && objCountParams.itwtrpls ? objCountParams.itwtrpls : '',
        itwtrtwt: chkBox == true && objCountParams.itwtrtwt ? objCountParams.itwtrtwt : '',
      };
      if (obj.iin == 'twitterpost') {
        obj.itwtpst = objCountParams.itwtpst;
        obj.itwtrpls = objCountParams.itwtrpls;
        obj.itwtrtwt = objCountParams.itwtrtwt;
      }
      if (pid) {
        obj.pid = pid;
      }
      if (obj.iin == 'twitterpost' && obj.isFromInt == 'twitterpost' && chkBox == true) {
        this.state.widgetById.dsi.filter(x => {
          if (x.uid == id && x.pid == pid) {
            x.itwtpst = objCountParams.itwtpst;
            x.itwtrpls = objCountParams.itwtrpls;
            x.itwtrtwt = objCountParams.itwtrtwt;
          }
        });
        this.state.lstActiveIntg.filter(x => {
          if (x.in == obj.iin && objInt && x.items.length == 0) {
            x.items.push(objInt);
          }
        });
        this.setState(this.state);
        this.props.addDataSrc(obj);
        //this.fnGetWidgetData();
      }
      else if (chkBox == true) {
        let stateDsi = this.state.widgetById;
        stateDsi.dsi.push(obj);
        this.state.widgetById = stateDsi;
        this.state.lstActiveIntg.filter(x => {
          if (x.in == obj.iin && objInt && x.items.length == 0) {
            x.items.push(objInt);
          }
        });
        this.setState(this.state);
        obj.exkw = this.state.widgetById.exkw;
        obj.inkw = this.state.widgetById.inkw;
        obj.ihwc = this.state.widgetById.ihwc;
        obj.ihwi = this.state.widgetById.ihwi;
        obj.mnrt = this.state.widgetById.mnrt;
        this.props.addDataSrc(obj);
        // if (obj.iin != 'facebookreview' || obj.iin != 'googlereview') {
        //   this.fnGetWidgetData();
        // }
        //common function for filter review data
      } else if (chkBox == false) {
        let dsiArr = [];
        if (pid && id) {
          dsiArr = this.state.widgetById.dsi;
          dsiArr.filter((x, i) => {
            if (x.uid == id && x.pid == pid) {
              dsiArr.splice(i, 1);
            }
          });
        } else if (!pid && id) {
          dsiArr = this.state.widgetById.dsi.filter(x => x.uid.toString() != id.toString());
        }
        this.state.widgetById.dsi = dsiArr;
        this.setState(this.state);
        this.props.delDataSrc(obj);
        //common function for filter review data
        //this.fnGetWidgetData();
      }
    }
    else {
      let obj = {
        uid: id,
        cn: this.props.location.query.cn,
        pgrtngavg: objCountParams.pgrtngavg ? objCountParams.pgrtngavg : 0,
        pglkcnt: objCountParams.pglkcnt ? objCountParams.pglkcnt : 0,
        pgflcnt: objCountParams.pgflcnt ? objCountParams.pgflcnt : 0,
        pgrtngcnt: objCountParams.pgrtngcnt ? objCountParams.pgrtngcnt : 0,
        pu: objCountParams.pu ? objCountParams.pu : '',
        iin: objCountParams.iin ? objCountParams.iin : '',
        rmk: objCountParams.rmk ? objCountParams.rmk : '',
        url: objCountParams.url ? objCountParams.url : '',
        dn: objCountParams.dn ? objCountParams.dn : '',
        isFromInt: objCountParams.isFromInt ? objCountParams.isFromInt : '',
        itwtpst: objCountParams.itwtpst ? objCountParams.itwtpst : '',
        itwtrpls: objCountParams.itwtrpls ? objCountParams.itwtrpls : '',
        itwtrtwt: objCountParams.itwtrtwt ? objCountParams.itwtrtwt : '',
        // widgetById: this.state.widgetById
      };
      if (obj.iin == 'twitterpost') {
        obj.itwtpst = objCountParams.itwtpst;
        obj.itwtrpls = objCountParams.itwtrpls;
        obj.itwtrtwt = objCountParams.itwtrtwt;
      }
      if (pid) {
        obj.pid = pid;
      }
      if (obj.iin == 'twitterpost' && obj.isFromInt == 'twitterpost' && chkBox == true) {
        this.state.widgetById.dsi.filter(x => {
          if (x.uid == id && x.pid == pid) {
            x.itwtpst = objCountParams.itwtpst;
            x.itwtrpls = objCountParams.itwtrpls;
            x.itwtrtwt = objCountParams.itwtrtwt;
          }
        });
        this.state.lstActiveIntg.filter(x => {
          if (x.in == obj.iin && objInt && x.items.length == 0) {
            x.items.push(objInt);
          }
        });
        this.setState(this.state);
        this.fnGetWidgetData();
      }
      else if (chkBox == true) {
        this.state.widgetById.dsi.push(obj);
        this.state.lstActiveIntg.filter(x => {
          if (x.in == obj.iin && objInt && x.items.length == 0) {
            x.items.push(objInt);
          }
        });
        this.setState(this.state);
        //common function for filter review data
        this.fnGetWidgetData();
      }
      else if (chkBox == false) {
        let dsiArr = [];
        if (pid && id) {
          dsiArr = this.state.widgetById.dsi;
          dsiArr.filter((x, i) => {
            if (x.uid == id && x.pid == pid) {
              dsiArr.splice(i, 1);
            }
          });
        }
        else if (id) {
          dsiArr = this.state.widgetById.dsi.filter(x => {
            if (x.uid != id) {
              return x;
            }
          });
        }
        this.state.widgetById.dsi = dsiArr;
        this.setState(this.state);
        //common function for filter review data
        this.fnGetWidgetData();
        localStorage.setItem('W_LOAD_DATA', false);
      }
    }
  }

  /************************layout*************************/
  //common fuction for get layout list from widget id
  fnGetLayoutList = (widId, cn) => {
    let arrLytlId = [];
    let _arrLylt = [];
    if (this.props.themeData) {
      let lstLayout = this.props.themeData.layout;
      //get the layout array from widId
      arrLytlId = this.props.themeData.widget.filter(x => x._id == widId)[0];
      //filter layout from layout list
      arrLytlId && arrLytlId.lytlst.filter(x => {
        lstLayout.filter(y => {
          if (x == y._id) {
            _arrLylt.push(y);
          }
        });
      });
      this.state.arrLylt = _arrLylt;

      //for get current category data    
      this.state.currCategory = this.props.themeData.category.filter(x => x.cn == cn)[0];
    }
    this.setState(this.state);
  }

  //common function for get card list from layout id
  fnGetCardAndPopupList = (lytlId, themeData) => {
    let objLytl = '';
    let _arrCard = [];
    let _arrPopup = [];
    let lstCard = themeData.card;
    let lstPopup = themeData.popup;
    objLytl = themeData.layout.filter(x => x._id == lytlId)[0];
    //for card list
    objLytl && objLytl.crdlst.filter(x => {
      lstCard.filter(y => {
        if (x == y._id) {
          _arrCard.push(y);
        }
      });
    });

    //for the popup list
    objLytl && objLytl.pplst.filter(x => {
      lstPopup.filter(y => {
        if (x == y._id) {
          _arrPopup.push(y);
        }
      });
    });
    this.state.arrPopup = _arrPopup;
    this.state.arrCard = _arrCard;

    //check current card is exists in _arrCard
    let objCrd = _arrCard.filter(x => x._id == this.state.currCardId)[0];
    if (!objCrd && _arrCard.length > 0) {
      this.state.currCardId = _arrCard[0]._id;
    }
    this.setState(this.state);
  }

  updateLayoutById = (temp_tmid) => {
    this.state.currLayoutId = temp_tmid;
    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
    this.fnGetCardAndPopupList(temp_tmid, this.props.themeData);
    //this.editorBackground();
  }

  //show editor setting
  handleEditorFocus = (type, ltn) => {
    if (document.getElementsByClassName('showEditor').length) {
      const arrShow = document.getElementsByClassName('showEditor');
      for (let i = 0; i < arrShow.length; i++) {
        const oShow = arrShow[i];
        oShow.classList.remove('showEditor');
      }
    }
    if (document.getElementsByClassName(type).length > 0)
      document.getElementsByClassName(type)[0].classList.add('showEditor');

    //for show thanks div
    const id = 'dashboard';
    const iframe = document.getElementById('w1fRamW1dget');
    let tnkDiv = iframe.contentWindow.document.getElementById('Wdgt_ReView_ThnkDiv_' + id);
    if (tnkDiv && (type == 'hdttxt' || type == 'cptxt' || type == 'tlsfstln' || type == 'tlssndln')) {
      tnkDiv.classList.remove('Wdgt_ReView_Thnk_shw');
    }

    if (tnkDiv && type == 'tlstrdln' && (ltn == 'automation_marketing' || ltn == 'review_collector_1' || ltn == 'review_collector_2')) {
      tnkDiv.classList.add('Wdgt_ReView_Thnk_shw');
    }
  }

  // //handle the quill editor background change
  // editorBackground = () => {
  //   setTimeout(() => {
  //     var arrEditor = '';
  //     if (document.getElementsByClassName('crdbg') && document.getElementsByClassName('crdbg').length > 0 && this.state.cnf) {
  //       arrEditor = document.getElementsByClassName('crdbg');
  //       for (let i = 0; i < arrEditor.length; i++) {
  //         const oEditor = arrEditor[i];
  //         oEditor.childNodes[1].style.background = this.state.cnf.crdbg;
  //       }
  //     }

  //     if (document.getElementsByClassName('bgclr') && document.getElementsByClassName('bgclr').length > 0 && this.state.cnf) {
  //       arrEditor = document.getElementsByClassName('bgclr');
  //       for (let i = 0; i < arrEditor.length; i++) {
  //         const oEditor = arrEditor[i];
  //         oEditor.childNodes[1].style.background = this.state.cnf.bgclr;
  //       }
  //     }

  //     //for apply tools header bg color in editor (whats app chat)
  //     if (document.getElementsByClassName('tlshdrbg') && document.getElementsByClassName('tlshdrbg').length > 0 && this.state.cnf) {
  //       arrEditor = document.getElementsByClassName('tlshdrbg');
  //       let _bgclr = this.state.cnf.tlshdrbg;
  //       if (this.props.location.query.wdtnm == 'sales_popup') {
  //         _bgclr = this.state.cnf.tlsbg;
  //       }
  //       for (let i = 0; i < arrEditor.length; i++) {
  //         const oEditor = arrEditor[i];
  //         oEditor.childNodes[1].style.background = _bgclr;
  //       }
  //     }

  //     if (document.getElementsByClassName('tlsmmbrbg') && document.getElementsByClassName('tlsmmbrbg').length > 0 && this.state.cnf) {
  //       arrEditor = document.getElementsByClassName('tlsmmbrbg');
  //       for (let i = 0; i < arrEditor.length; i++) {
  //         const oEditor = arrEditor[i];
  //         oEditor.childNodes[1].style.background = this.state.cnf.tlsmmbrbg;
  //       }
  //     }

  //     //for apply tools bg color in editor (countdown timer)
  //     if (document.getElementsByClassName('tlsbg') && document.getElementsByClassName('tlsbg').length > 0 && this.state.cnf) {
  //       arrEditor = document.getElementsByClassName('tlsbg');
  //       for (let i = 0; i < arrEditor.length; i++) {
  //         const oEditor = arrEditor[i];
  //         oEditor.childNodes[1].style.background = this.state.cnf.tlsbg;
  //       }
  //     }
  //   }, 1);
  // }

  /***********************post card***********************/
  openIconModel = (iconType, state, childState) => {
    this.state.isLoadIcon = true;
    this.state.iconType = iconType;
    this.state.iconstate = state;
    this.state.iconchildState = childState;
    this.props.getIconList();
    this.state.openCloseIconModel = true;
    this.setState(this.state);
    this.searchIconscout();
  }

  iconModelCont = () => {
    let myIcon, native;
    if (this.props.iconList) {
      myIcon = this.props.iconList.filter(x => x.ic == 'my');
      native = this.props.iconList.filter(x => x.ic == 'native');
    }
    return (
      <IconCard
        handleBase64File={this.handleBase64File}
        updWidgetIcon={this.updWidgetIcon}
        isLoadIcon={this.state.isLoadIcon}
        isLoadIconscout={this.state.isLoadIconscout}
        handleIconChange={this.handleIconChange}
        iconLabel={this.state.iconLabel}
        deleteIcon={this.deleteIcon}
        myIcon={myIcon}
        native={native}
        iconValidator={this.iconValidator}
        iconscout={this.state.iconscout}
        arrIconscout={this.state.arrIconscout}
        handleIconTextChange={this.handleIconTextChange}
        handleIconKeypress={this.handleIconKeypress}
        searchIconscout={this.searchIconscout}
        handleIconscoutFile={this.handleIconscoutFile} />
    );
    //<div className="modal-body wdgt-icon-setting">
    //  <div className="mdl-icon-upload">
    //    <ImageUploader
    //      className='simpple'
    //      fileContainerStyle={{ padding: 0, display: 'block', background: 'rgba(0,0,0,0)', WebkitBoxShadow: 'none', boxShadow: 'none', margin: 0 }}
    //      buttonClassName=''
    //      buttonStyles={{}}
    //      className={''}
    //      withIcon={false}
    //      withLabel={true}
    //      label={this.state.iconLabel ? this.state.iconLabel : ''}
    //      labelStyles={{ float: 'right' }}
    //      buttonText='Browse'
    //      singleImage={true}
    //      onChange={this.handleBase64File}
    //      imgExtension={['.jpg', '.jpeg', '.png', '.svg', '.gif']}
    //      maxFileSize={5242880} />
    //    <input className="nf-btn nf-btn-default  nf-btn-min15x" type='button' value='UPLOAD'
    //      onClick={() => this.updWidgetIcon()} />
    //  </div>
    //  <div className="wdgt-iconmodal-block">
    //    {this.state.isLoadIcon == false ?
    //      this.props.iconList && this.props.iconList.map((val, key) => {
    //        return (
    //          <div className="icon-gallery-item" key={key}>
    //            <div className="icon-gallery-box">
    //              <span className="tbl-action-dlt action-dlt-icongallery" onClick={() => this.deleteIcon(val._id, val.iu)}><img className="" src={IconDelete} alt="Delete" />
    //              </span>
    //              <img src={val.iu} alt="icon" onClick={() => this.handleIconChange(val.iu)} />
    //            </div>
    //          </div>
    //        );
    //      })
    //      :
    //      <ContentLoader
    //        height={450}
    //        width={700}
    //        speed={2}
    //        primaryColor="#eceef4"
    //        secondaryColor="#fff">
    //        <rect x="20" y="25" rx="0" ry="0" width="75" height="75" />
    //        <rect x="110" y="25" rx="0" ry="0" width="75" height="75" />
    //        <rect x="200" y="25" rx="0" ry="0" width="75" height="75" />
    //        <rect x="290" y="25" rx="0" ry="0" width="75" height="75" />
    //        <rect x="380" y="25" rx="0" ry="0" width="75" height="75" />
    //        <rect x="470" y="25" rx="0" ry="0" width="75" height="75" />
    //        <rect x="560" y="25" rx="0" ry="0" width="75" height="75" /
    //        <rect x="20" y="115" rx="0" ry="0" width="75" height="75" />
    //        <rect x="110" y="115" rx="0" ry="0" width="75" height="75" />
    //        <rect x="200" y="115" rx="0" ry="0" width="75" height="75" />
    //        <rect x="290" y="115" rx="0" ry="0" width="75" height="75" />
    //        <rect x="380" y="115" rx="0" ry="0" width="75" height="75" />
    //        <rect x="470" y="115" rx="0" ry="0" width="75" height="75" />
    //        <rect x="560" y="115" rx="0" ry="0" width="75" height="75" /
    //        <rect x="20" y="205" rx="0" ry="0" width="75" height="75" />
    //        <rect x="110" y="205" rx="0" ry="0" width="75" height="75" />
    //        <rect x="200" y="205" rx="0" ry="0" width="75" height="75" />
    //        <rect x="290" y="205" rx="0" ry="0" width="75" height="75" />
    //        <rect x="380" y="205" rx="0" ry="0" width="75" height="75" />
    //        <rect x="470" y="205" rx="0" ry="0" width="75" height="75" />
    //        <rect x="560" y="205" rx="0" ry="0" width="75" height="75" /
    //        <rect x="20" y="295" rx="0" ry="0" width="75" height="75" />
    //        <rect x="110" y="295" rx="0" ry="0" width="75" height="75" />
    //        <rect x="200" y="295" rx="0" ry="0" width="75" height="75" />
    //        <rect x="290" y="295" rx="0" ry="0" width="75" height="75" />
    //        <rect x="380" y="295" rx="0" ry="0" width="75" height="75" />
    //        <rect x="470" y="295" rx="0" ry="0" width="75" height="75" />
    //        <rect x="560" y="295" rx="0" ry="0" width="75" height="75" />
    //      </ContentLoader>
    //    }
    //  </div>
    //</div>
  }

  closeIconModel = () => {
    this.state.openCloseIconModel = false;
    this.state.iconLabel = '';
    this.setState(this.state);
  }

  //convert image in base64 file
  handleBase64File = (file) => {
    if (file && file.length > 0) {
      this.base64FileURL(file[0], (obj) => {
        this.state.iconUrl = obj;
        this.state.iconLabel = file[0].name;
        this.setState(this.state);
      });
    }
  }

  //on select iconscout file store google clould
  handleIconscoutFile = (url) => {
    this.imgUrlToBase64(url, (base64) => {
      this.setState({ iconUrl: base64 });
      this.updWidgetIcon(); //for upload image in google clould
    });
  }

  //convert image url to base64 file
  imgUrlToBase64 = (url, callback) => {
    var xhr = new window.XMLHttpRequest();
    xhr.onload = function () {
      var reader = new window.FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  updWidgetIcon = () => {
    if (this.state.iconUrl) {
      let objIcon = {
        icon: this.state.iconUrl
      };
      this.props.updWidgetIcon(objIcon);

      this.state.isLoadIcon = true;
      this.state.iconUrl = '';
      this.state.iconLabel = '';
      this.setState(this.state);
    }
  }

  //base64 file convert
  base64FileURL = (element, callback) => {
    let file = element;
    let reader = new window.FileReader();
    reader.onloadend = function (e) {
      callback(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  updateCardById = (crdId) => {
    this.state.currCardId = crdId;
    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
  }

  //delete icon
  deleteIcon = (id, url) => {
    const obj = {
      id: id,
      url: url
    };
    this.state.isLoadIcon = true;
    this.setState(this.state);
    this.props.deleteIcon(obj);
  }

  //handle iconscout change event
  handleIconTextChange = (value) => {
    this.state.iconscout = value;
    this.setState(this.state);
  }

  //handle search icon scout
  searchIconscout = async () => {
    let that = this;
    if (!that.iconValidator.allValid()) {
      that.iconValidator.showMessages();
      that.forceUpdate();
    }
    else {
      this.state.isLoadIconscout = true;
      this.setState(this.state);
      let _arrData = [];
      await fetch('https://api.iconscout.com/v2/search?query=' + this.state.iconscout + '&product_type=item&asset=icon&price=free&per_page=200&page=1&sort=popular&quality=false', {
        method: 'GET',
        headers: {
          'Client-Id': 279435890707056,
        }
      }).then(res => res.json()).then((res) => {
        let data = res.response.items.data;
        for (let i = 0; i < data.length; i++) {
          _arrData.push(data[i].urls.png_128);
        }
      });
      this.state.isLoadIconscout = false;
      this.state.arrIconscout = _arrData;
      this.setState(this.state);
    }
  }

  //handle enter keypress search
  handleIconKeypress = (e) => {
    let code = e.keyCode || e.which;
    if (code == 13) {
      this.searchIconscout();
    }
  }

  //
  handleIconChange = (url) => {
    if (this.state.iconType == 'arrimg1') {
      this.handleArrayChange('arrimg1', this.state.iconstate, url);
    } else if (this.state.iconType == 'arrimg2') {
      this.handleArrayChange('arrimg2', this.state.iconstate, url);
    } else if (this.state.iconType == 'tlsicn') {
      this.state.cnf.tlsicn = url;
    } else if (this.state.iconType == 'flbkimgurl') {
      this.state.cnf.flbkimgurl = url;
    } else if (this.state.iconType == 'tlshdricn') {
      this.state.cnf.tlshdricn = url;
    } else if (this.state.iconType == 'arrctaicn') {
      this.handleArrayChange('arrctaicn', this.state.iconstate, url);
    } else if (this.state.iconType == 'icn') {
      this.handleChildArrayChange('icn', url, this.state.iconstate, this.state.iconchildState);
    }

    this.state.openCloseIconModel = false;
    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
  }

  handleSchemaStore = () => {
    let obj = {
      _id: this.props.location.query.id,
      scmcmpnm: this.state._scmcmpnm,
      scmathr: this.state._scmathr,
      scmimgurl: this.state._scmimgurl,
      scmdsc: this.state._scmdsc,
      scmctgry: this.state._scmctgry,
    };
    this.props.updSchemaValue(obj);
    this.setState(this.state);
  }

  handleCnfChange = (name, value, type) => {
    //convert rgba to hex. bcz we also need alpha value
    if (type == 'rgb') {
      let alpha = value.a > 0.1 ? value.a : 0.1;
      const r = value.r.toString(16).length == 2 ? value.r.toString(16) : ('0' + value.r.toString(16));
      const g = value.g.toString(16).length == 2 ? value.g.toString(16) : ('0' + value.g.toString(16));
      const b = value.b.toString(16).length == 2 ? value.b.toString(16) : ('0' + value.b.toString(16));
      value = '#' + r + g + b + (alpha === 0 ? '00' : Math.round(255 * alpha).toString(16));
    }

    if (name == 'atmntgrevrydt' || name == 'atmntgrevrywk') {
      for (let i = 0; i < value.length; i++) {
        let _obj = value[i];
        if (_obj.value) {
          value[i] = _obj.value;
        }
      }
    }

    const { cnf } = { ...this.state };
    const currentState = cnf;
    //for the card shadow
    if (name === 'crdshdnone') {
      currentState['crdshdhz'] = '0';
      currentState['crdshdvl'] = '0';
      currentState['crdshdblr'] = '0';
    } else if (name === 'crdshdleft') {
      currentState['crdshdhz'] = '6';
      currentState['crdshdvl'] = '6';
      currentState['crdshdblr'] = '12';
    } else if (name === 'crdshdright') {
      currentState['crdshdhz'] = '-6';
      currentState['crdshdvl'] = '-6';
      currentState['crdshdblr'] = '12';
    }

    //for popup shadow
    if (name === 'ppshdnone') {
      currentState['ppshdhz'] = '0';
      currentState['ppshdvl'] = '0';
      currentState['ppshdblr'] = '0';
    } else if (name === 'ppshdleft') {
      currentState['ppshdhz'] = '5';
      currentState['ppshdvl'] = '5';
      currentState['ppshdblr'] = '10';
    } else if (name === 'ppshdright') {
      currentState['ppshdhz'] = '-5';
      currentState['ppshdvl'] = '-5';
      currentState['ppshdblr'] = '10';
    }

    //for toos shadow
    if (name === 'tlsshdnone') {
      currentState['tlsshdhz'] = '0';
      currentState['tlsshdvl'] = '0';
      currentState['tlsshdblr'] = '0';
    } else if (name === 'tlsshdleft') {
      currentState['tlsshdhz'] = '6';
      currentState['tlsshdvl'] = '6';
      currentState['tlsshdblr'] = '10';
    } else if (name === 'tlsshdright') {
      currentState['tlsshdhz'] = '-6';
      currentState['tlsshdvl'] = '-6';
      currentState['tlsshdblr'] = '10';
    }

    //for the change theme color
    if (name === 'lyclrtyp') {
      if (value == '1') { //dark theme
        if (this.state.cnf.crdcptntxtclr) currentState['crdcptntxtclr'] = '#ffffffb3';              //caption font color
        if (this.state.cnf.crdactnfnclr) currentState['crdactnfnclr'] = '#ffffff99'; //like count font color
        if (this.state.cnf.hdttxt) currentState['cmnhdrclra'] = '#FFFFFF';        //Header Title font color
        if (this.state.cnf.hdttxt) currentState['cmnhdrclrb'] = '#FFFFFF';        //Header Caption font color  
        if (this.state.cnf.crdfclr) currentState['crdfclr'] = '#fff';       //card font color
        if (this.state.cnf.crdatclr) currentState['crdatclr'] = '#FFFFFF';      //Author color
        if (this.state.cnf.crddtclr) currentState['crddtclr'] = '#ffffffb3';   //card date color
        if (this.state.cnf.crdbg) currentState['crdbg'] = '#212529';         //card background
        if (this.state.cnf.bgclr) currentState['bgclr'] = '#000';      //background
        if (this.state.cnf.crdhtgfntclr) { currentState['crdhtgfntclr'] = '#0072BB'; } //card hashtag font color
        if (this.state.cnf.crdhtgbgclr) { currentState['crdhtgbgclr'] = '#03a9f400'; } //card hashtag bg color 
        if (this.state.cnf.cmntbclr) currentState['cmntbclr'] = '#fff';           // tab font color
        if (this.state.cnf.arwbgclr) currentState['arwbgclr'] = '#fff';           // arw bg color
        if (this.state.cnf.arwclr) currentState['arwclr'] = '#000';              // arw color

        //common color 
        if (this.state.cnf.cmncrdctgyclr != undefined) { currentState['cmncrdctgyclr'] = '#ffffff'; }
        if (this.state.cnf.cmncrdttlclr != undefined) { currentState['cmncrdttlclr'] = '#ffffff'; }
        if (this.state.cnf.cmncrddescclr != undefined) { currentState['cmncrddescclr'] = '#ffffff80'; }
        if (this.state.cnf.cmncrdlctnclr != undefined) { currentState['cmncrdlctnclr'] = '#ffffff80'; }
        if (this.state.cnf.cmncrdjbtypclr != undefined) { currentState['cmncrdjbtypclr'] = '#ffffff80'; }
        if (this.state.cnf.cmncrddsgnclr != undefined) { currentState['cmncrddsgnclr'] = '#ffffff'; }
        if (this.state.cnf.cmncrdslryclr != undefined) { currentState['cmncrdslryclr'] = '#ffffff'; }

      } else { //light theme
        if (this.state.cnf.crdcptntxtclr) currentState['crdcptntxtclr'] = '#656565';              //caption font color
        if (this.state.cnf.crdactnfnclr) currentState['crdactnfnclr'] = '#656565';              //like count font color
        if (this.state.cnf.hdttxt) currentState['cmnhdrclra'] = '#000000';              //Header Title font color
        if (this.state.cnf.hdttxt) currentState['cmnhdrclrb'] = '#000000';              //Header Caption font color 
        if (this.state.cnf.crdfclr) currentState['crdfclr'] = '#656565';            //card font color
        if (this.state.cnf.crdatclr) currentState['crdatclr'] = '#000000ff';          //Author color
        if (this.state.cnf.crddtclr) currentState['crddtclr'] = '#656565';       //card date color
        if (this.state.cnf.crdbg) currentState['crdbg'] = '#ffffffff';             //card background
        if (this.state.cnf.bgclr) currentState['bgclr'] = '#F3F3F9';             //background
        if (this.state.cnf.crdhtgfntclr) { currentState['crdhtgfntclr'] = '#0072BB'; } //card hashtag font color
        if (this.state.cnf.crdhtgbgclr) { currentState['crdhtgbgclr'] = ' #03a9f400'; }  //card hashtag bg color
        if (this.state.cnf.cmntbclr) currentState['cmntbclr'] = '#000';           // tab font color
        if (this.state.cnf.arwbgclr) currentState['arwbgclr'] = '#8c8c8ea1';           // arw bg color
        if (this.state.cnf.arwclr) currentState['arwclr'] = '#fdfdfdff';              // arw color

        //common color 
        if (this.state.cnf.cmncrdctgyclr != undefined) { currentState['cmncrdctgyclr'] = '#000'; }
        if (this.state.cnf.cmncrdttlclr != undefined) { currentState['cmncrdttlclr'] = '#111111'; }
        if (this.state.cnf.cmncrddescclr != undefined) { currentState['cmncrddescclr'] = '#11111180'; }
        if (this.state.cnf.cmncrdlctnclr != undefined) { currentState['cmncrdlctnclr'] = '#11111180'; }
        if (this.state.cnf.cmncrdjbtypclr != undefined) { currentState['cmncrdjbtypclr'] = '#11111180'; }
        if (this.state.cnf.cmncrddsgnclr != undefined) { currentState['cmncrddsgnclr'] = '#222222'; }
        if (this.state.cnf.cmncrdslryclr != undefined) { currentState['cmncrdslryclr'] = '#111111'; }
      }
    }
    currentState[name] = value;

    //for Embed video url in video widget
    if (name === 'vdurl') {
      let match = value.match(regExp_youtube);
      if (match && match[2].length == 11) {
        //for autoplay video   
        let isAuto = 0;
        let isMute = 0;
        let isRel = 0;
        if (this.state.cnf.vdiatpl == true) {
          isAuto = 1;
        }
        if (this.state.cnf.vdimt == true) {
          isMute = 1;
        }
        if (this.state.cnf.vdisrltd == true) {
          isRel = 1;
        }
        currentState.vdurl = 'https://www.youtube.com/embed/' + match[2] + '?autoplay=' + isAuto + '&mute=' + isMute + '&rel=' + isRel + '';
      }
    }
    //for set autoplay video in video widget
    if (name === 'vdiatpl') {
      if (value === true) {
        currentState.vdurl = currentState.vdurl.replace('autoplay=0', 'autoplay=1');
      } else {
        currentState.vdurl = currentState.vdurl.replace('autoplay=1', 'autoplay=0');
      }
    }

    //mute video in video widget
    if (name === 'vdimt') {
      if (value === true) {
        currentState.vdurl = currentState.vdurl.replace('mute=0', 'mute=1');
      } else {
        currentState.vdurl = currentState.vdurl.replace('mute=1', 'mute=0');
      }
    }

    //mute video in video widget
    if (name === 'vdisrltd') {
      if (value === true) {
        currentState.vdurl = currentState.vdurl.replace('rel=0', 'rel=1');
      } else {
        currentState.vdurl = currentState.vdurl.replace('rel=1', 'rel=0');
      }
    }

    this.setState(this.state);
    this.setState({ cnf: currentState });

    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
      this.setState(this.state);
    }

    //on change animation not apply in preview
    window['W_IS_ANI_APLY'] = false;
    if (name == 'dskanm' || name == 'mblanm' || name == 'dskpos' || name == 'mblpos') {
      window['W_IS_ANI_APLY'] = true;
    }

    //on change thank you div font size and color show thank you div 
    window['W_IS_THK_DV'] = false;
    const id = 'dashboard';
    const iframe = document.getElementById('w1fRamW1dget');
    if (iframe) {
      let tnkDiv = iframe.contentWindow.document.getElementById('Wdgt_ReView_ThnkDiv_' + id);
      if (tnkDiv) {
        if (name === 'tlstrdln' || name === 'cmncrdddnb' || name === 'cmncrdclrb' || name === 'cmncrdddne' || name === 'cmncrdclre') {
          window['W_IS_THK_DV'] = true;
        }
      }
    }
  }

  handleWidgetChange = (name, value) => {
    const { widgetById } = { ...this.state };
    const currentState = widgetById;
    currentState[name] = value;
    this.setState({ widgetById: currentState });

    if (name == 'ihwc' || name == 'ihwi' || name == 'mnrt') {
      //common function for filter review data
      this.fnGetWidgetData();
      ////create API for onChange save
      let obj = {
        name, value,
        widgetById: widgetById._id
      };
      this.props.onChangeSaveFilter(obj);
    }

    if (name !== 'ihwc' && name !== 'ihwi' && name !== 'mnrt' && name !== 'scmcmpnm' &&
      name !== 'scmathr' && name !== 'scmimgurl' && name !== 'scmdsc' && name !== 'scmctgry') {
      if (!this.state.isEditWidget) {
        this.state.isEditWidget = true;
        this.setState(this.state);
      }
    }
  }

  handleSchemaChange = (name, value) => {
    if (name == 'scmcmpnm') {
      this.state._scmcmpnm = value;
    }
    else if (name == 'scmctgry') {
      this.state._scmctgry = value;
    }
    else if (name == 'scmathr') {
      this.state._scmathr = value;
    }
    else if (name == 'scmdsc') {
      this.state._scmdsc = value;
    }
    else if (name == 'scmimgurl') {
      this.state._scmimgurl = value;
    }
    this.setState(this.state);
  }

  handleChkArray = (state, value) => {
    //for handle setting card days array   
    const { widgetById } = { ...this.state };
    const currentState = widgetById;
    if (currentState['arrptdy'] == undefined) {
      currentState['arrptdy'] = [];
    }
    if (value == true) {
      currentState['arrptdy'].push(state);
    } else {
      for (var i = 0; i < currentState['arrptdy'].length; i++) {
        if (currentState['arrptdy'][i] == state) {
          currentState['arrptdy'].splice(i, 1);
        }
      }
    }
    this.state.widgetById = currentState;
    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
  }

  handleArrayChange = (name, state, value, type) => {
    if (name === 'arrdt' && value == undefined) {
      value = '';
    }
    //convert rgba to hex. bcz we also need alpha value
    if (type == 'rgb') {
      let alpha = value.a > 0.1 ? value.a : 0.1;
      const r = value.r.toString(16).length == 2 ? value.r.toString(16) : ('0' + value.r.toString(16));
      const g = value.g.toString(16).length == 2 ? value.g.toString(16) : ('0' + value.g.toString(16));
      const b = value.b.toString(16).length == 2 ? value.b.toString(16) : ('0' + value.b.toString(16));
      value = '#' + r + g + b + (alpha === 0 ? '00' : Math.round(255 * alpha).toString(16));
    }

    const { cnf } = { ...this.state };
    if (this.state.arrName == 'tlsctarr') {
      const currentState = cnf.tlsctarr;
      currentState[state][name] = value;
      this.state.cnf.tlsctarr = currentState;

      if (name == 'arrfl' || name == 'arrimg1') { //when category name change then apply new name in tlsdtarr data
        let tlsctarr = this.state.cnf.tlsctarr[state];
        let _arrData = this.state.cnf.tlsdtarr.filter(x => x.ct_id == tlsctarr.ct_id);
        if (_arrData && _arrData.length > 0) {
          for (let i = 0; i < _arrData.length; i++) {
            if (_arrData[i].arrddnfl != undefined) {
              _arrData[i].arrddnfl = tlsctarr.arrfl;
              _arrData[i].dn = tlsctarr.arrfl;
            }
            if (tlsctarr.arrimg1 != undefined)
              _arrData[i].arrimg1 = tlsctarr.arrimg1;
          }
        }
      }
    } else {
      const currentState = cnf.tlsdtarr;
      currentState[state][name] = value;
      this.state.cnf.tlsdtarr = currentState;

      if (name == 'ct_id') {
        let tlsctarr = this.state.cnf.tlsctarr.filter(x => x.ct_id == value)[0];
        let tlsdtarr = this.state.cnf.tlsdtarr[state];

        if (tlsctarr.arrfl != undefined) {
          tlsdtarr.arrddnfl = tlsctarr.arrfl;
          tlsdtarr.dn = tlsctarr.arrfl;
        }
        if (tlsctarr.arrimg1 != undefined) {
          tlsdtarr.arrimg1 = tlsctarr.arrimg1;
        }
      }
    }
    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
  }

  handleChildArrayChange = (name, value, state, childState, subChildState) => {
    const { cnf } = { ...this.state };
    const currentState = cnf.tlsdtarr[state].arradmr;
    if (name == 'optn') {
      currentState[childState][name][subChildState] = value;
    } else {
      currentState[childState][name] = value;
    }
    this.state.cnf.tlsdtarr[state].arradmr = currentState;
    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
  }

  handleArrayDrag = (arr, name, dragResult) => {
    const { removedIndex, addedIndex, payload } = dragResult;
    if (removedIndex === null && addedIndex === null) return arr;
    const result = [...arr];
    let itemToAdd = payload;
    if (removedIndex !== null) itemToAdd = result.splice(removedIndex, 1)[0];
    if (addedIndex !== null) result.splice(addedIndex, 0, itemToAdd);

    this.state.cnf[name] = result;

    //on change show save btn.
    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
    return result;
  }

  handleEnterEvent = (type, event, key) => {
    if (event.key === 'Enter') {
      //for include keyword
      if (type == 'inkw') {
        // this.state.includeChips = this.state.includeChips.replace(/\s+/g, '').trim();
        if (this.state.includeChips != '') {
          this.state.widgetById.inkw.push(this.state.includeChips);
        }
        ////update value in DB
        let obj = {
          name: type, widgetById: this.state.widgetById._id,
          value: this.state.widgetById.inkw
        };
        this.props.onChangeSaveFilter(obj);
        this.state.includeChips = '';
      } else if (type == 'exkw') { //for exclude keyword
        // this.state.excludeChips = this.state.excludeChips.replace(/\s+/g, '').trim();
        if (this.state.excludeChips != '') {
          this.state.widgetById.exkw.push(this.state.excludeChips);
        }
        this.state.excludeChips = '';
        ////update value in DB
        let obj = {
          name: type, widgetById: this.state.widgetById._id,
          value: this.state.widgetById.exkw
        };
        this.props.onChangeSaveFilter(obj);
      } else if (type == 'arrchipsfl') {
        this.state.jobSkillChips = this.state.jobSkillChips.replace(/\s+/g, '').trim();
        if (this.state.jobSkillChips != '') {
          this.state.cnf.tlsdtarr[key].arrchipsfl.push(this.state.jobSkillChips);
        }
        ////update value in DB
        let obj = {
          name: type, widgetById: this.state.widgetById._id,
          value: this.state.includeChips
        };
        this.props.onChangeSaveFilter(obj);
        this.state.jobSkillChips = '';
      }
      if (type !== 'inkw' && type !== 'exkw') {
        if (!this.state.isEditWidget) {
          this.state.isEditWidget = true;
        }
      }
      this.setState(this.state);
      //common function for filter review data
      this.fnGetWidgetData();
    }
  }

  removeChips = (type, state, key) => {
    if (type === 'inkw') {
      this.state.widgetById.inkw.splice(state, 1);
      ////update value in DB
      let obj = {
        name: type, widgetById: this.state.widgetById._id,
        value: this.state.widgetById.inkw
      };
      this.props.onChangeSaveFilter(obj);
    } else if (type === 'exkw') {
      this.state.widgetById.exkw.splice(state, 1);
      ////update value in DB
      let obj = {
        name: type, widgetById: this.state.widgetById._id,
        value: this.state.widgetById.exkw
      };
      this.props.onChangeSaveFilter(obj);
    } else if (type === 'arrchipsfl') {
      this.state.cnf.tlsdtarr[key].arrchipsfl.splice(state, 1);
    }
    if (type !== 'inkw' && type !== 'exkw') {
      if (!this.state.isEditWidget) {
        this.state.isEditWidget = true;
      }
    }
    this.setState(this.state);
    //common function for filter review data
    this.fnGetWidgetData();
  }

  handleColorPicker = (type) => {
    if (type) {
      this.state.colorPick = type;
      this.setState(this.state);
    }
  }

  handleColorPickerClose = () => {
    this.state.colorPick = '';
    this.setState(this.state);
  }

  fnCheckFieldIsDisplayOrNot = (fieldName, obj) => {
    let fieldExists = true;
    if (obj && obj.exclcnf) {
      fieldExists = obj.exclcnf.filter(x => x == fieldName).length > 0 ? false : true;
    }
    return fieldExists;
  }

  openCloseStoryDataPanel = (obj, key, arrName) => {
    this.state.openCloseStoryData = !this.state.openCloseStoryData;
    if (this.state.openCloseStoryData == true && obj) {
      this.state.arrName = arrName;
      this.state.objStoryData = obj;
      this.state.objStoryData.key = key;
      //this.editorBackground();
      localStorage.setItem('W_FEED_SLIDE', key);
    } else {
      let colneData = JSON.parse(this.state.cloneWidgetById);
      this.state.cnf.tlsdtarr = colneData.cnf.tlsdtarr;

      if (colneData.cnf.tlsctarr != undefined) {
        this.state.cnf.tlsctarr = colneData.cnf.tlsctarr;
      }
      localStorage.removeItem('W_FEED_SLIDE');
    }
    this.setState(this.state);
  }

  AddfieldinArw = (name) => {
    if (name == 'chat_widget') {
      if (this.props.location.query.wdtnm == 'allinonechat') {
        this.state.cnf.tlsdtarr.push({
          'arrfled': 'Enter the title',
          'arriimg': false,
          'arrimg1': 'https://storage.googleapis.com/widget_img/widget/avatar.png',
          'arrfl': ' '
        });
      }
      else {
        this.state.cnf.tlsdtarr.push({
          'arrfled': 'Enter the title',
          'arrsled': 'Customer Support',
          'arrtled': 'Hi ',
          'arrimg1': 'https://storage.googleapis.com/widget_img/widget/avatar.png',
          'arrfl': '+1 ',
          'bgc': '#F5F7F9',
        });
      }
    } else if (name == 'tlsdtarr') {
      let rndCode = Math.floor(Math.random() * 100);
      if (this.props.location.query.wdtnm == 'story_widget') {
        this.state.cnf.tlsdtarr.push({
          'arrddnfl': '',
          'ct_id': '',
          'arrfled': '<h3><strong style="color: rgb(0, 0, 0);"> </strong></h3>',
          'arrsled': '<p><span style="color: rgb(90, 90, 90);"> </span></p>',
          'arrctaiicn': true,
          'arrctaurl': '',
          'arrctaicn': 'https://storage.googleapis.com/widget_img/widget/features_share.svg',
          'arrdt': new Date(),
          'arrimg1': 'https://storage.googleapis.com/widget_img/widget/default_share.png'
        });
      }
      else if (this.props.location.query.wdtnm == 'job_board') {
        // this.editorBackground();
        this.state.cnf.tlsdtarr.push({
          '_id': 'job_' + rndCode,
          'arrfled': '<p><span style="color: rgb(140, 140, 140);"> </span></p>',
          'arrsled': '<p><span style="color: rgb(140, 140, 140);"> </span></p>',
          'arrtled': '<p><span style="color: rgb(140, 140, 140);"> </span></p>',
          'arrfrtled': '<p><span style="color: rgb(140, 140, 140);"> </span></p>',
          'arrfftled': '<p><span style="color: rgb(140, 140, 140);"> </span></p>',
          'arrsxtled': '<p><span style="color: rgb(140, 140, 140);"> </span></p>',
          'arrchipsfl': [],
          'arrctalbl': '',
          'arrctaurl': ''
        });
      }
      else if (this.props.location.query.wdtnm == 'tool_slider') {
        this.state.cnf.tlsdtarr.push({
          '_id': 'slide_' + rndCode,
          'arrctaiicn': true,
          'arrctapstn': 'center',
          'arrctalbl': '',
          'arrctaurl': '',
          'arrimg1': 'https://storage.googleapis.com/widget_img/widget/default_share.png',
          'arrfled': '<h1 class="ql-align-center"><strong style="color: rgb(0, 0, 0);"> </strong></h1>',
          'arrsled': '<h3 class="ql-align-center"><span style="color: rgb(102, 102, 102);"> </span></h3>',
          'arrdt': new Date(),
          'arrdtpstn': 'center'
        });
      }
      else if (this.props.location.query.wdtnm == 'faq') {
        this.state.cnf.tlsdtarr.push({
          '_id': 'faq_' + rndCode,
          'ct_id': '',
          'arrddnfl': '',
          'arrfled': '',
          'arrsled': ''
        });
      }
      else if (this.props.location.query.wdtnm == 'feedback') {
        this.state.cnf.tlsdtarr.push({
          '_id': 'feedback_' + rndCode,
          'arrimg1': '',
          'arrfled': '',
          'arrfl': '',
          'arrsl': '',
          'arradmr': [{
            'irqrd': false,
            'ilbl': true,
            'lbl': '',
            'typ': '',//textbox, radio button...
            'optn': [''],
            'plchldr': '',
            'rtngclr': ''
          }]
        });
      }
      else if (this.props.location.query.wdtnm == 'tool_restaurant') {
        this.state.cnf.tlsdtarr.push({
          'ct_id': '',
          'arrddnfl': '',
          'arrimg1': '',
          'arrfled': '<h4><strong style="color: rgb(123 128 128);"> </strong></h4>',
          'arrsled': '<p><span style="color: rgb(107, 107, 107);"> </span></p>',
          'arrtled': '<p><span style="color: rgb(140, 140, 140);"> </span></p>',
          'arrimg2': ''
        });
      }
      else if (this.props.location.query.wdtnm == 'tool_team_showcase') {
        this.state.cnf.tlsdtarr.push({
          '_id': 'team_' + rndCode,
          'ct_id': '',
          'arrddnfl': '',
          'dn': '',
          'arrfled': '',
          'arrfl': '',
          'arrsl': '',
          'arrsled': '',
          'arrtl': '',
          'arrtled': '',
          'arrfrtled': '',
          'arrimg1': '',
          'arradmr': [
            {
              'icn': '',
              'url': ''
            }
          ]
        });
      }
      else if (this.props.location.query.wdtnm == 'tool_pricing') {
        this.state.cnf.tlsdtarr.push({
          '_id': 'pln_' + rndCode,
          'ct_id': '',
          'arrddnfl': '',
          'dn': 'Monthly',
          'arrfled': '',
          'arrsled': '',
          'arrtled': '',
          'arrfrtled': '',
          'arrfftled': '',
          'arrimg1': '',
          'arrctaiicn': true,
          'arrctalbl': '',
          'arrctaurl': ''
        });
      } else if (this.props.location.query.wdtnm == 'tool_number_animation') {
        this.state.cnf.tlsdtarr.push({
          '_id': 'num_' + rndCode,
          'arrfl': '',
          'arrfled': '',
          'arrsled': '',
          'arrtled': '',
          'arrimg1': ''
        });
      }
      this.state.openCloseStoryData = true;
      this.state.arrName = name;
      let lastIndex = this.state.cnf.tlsdtarr.length - 1;
      this.state.objStoryData = this.state.cnf.tlsdtarr[lastIndex];
      this.state.objStoryData.key = lastIndex;

    } else if (name == 'tlsctarr') {
      let rndCode = Math.floor(Math.random() * 1000);
      if (this.props.location.query.wdtnm == 'story_widget') {
        this.state.cnf.tlsctarr.push({
          'ct_id': 'stry_ct_' + rndCode,
          'arrfl': '',
        });
      } else if (this.props.location.query.wdtnm == 'faq') {
        this.state.cnf.tlsctarr.push({
          'ct_id': 'faq_ct_' + rndCode,
          'arrfl': '',
        });
      } else if (this.props.location.query.wdtnm == 'tool_restaurant') {
        this.state.cnf.tlsctarr.push({
          'ct_id': 'rest_ct_' + rndCode,
          'arrfl': '',
          'arrimg1': '',
        });
      } else if (this.props.location.query.wdtnm == 'tool_team_showcase') {
        this.state.cnf.tlsctarr.push({
          'ct_id': 'team_ct_' + rndCode,
          'arrfl': '',
        });
      } else if (this.props.location.query.wdtnm == 'tool_pricing') {
        this.state.cnf.tlsctarr.push({
          'ct_id': 'pln_ct_' + rndCode,
          'arrfl': '',
        });
      }

      this.state.openCloseStoryData = true;
      this.state.arrName = name;
      let lastIndex = this.state.cnf.tlsctarr.length - 1;
      this.state.objStoryData = this.state.cnf.tlsctarr[lastIndex];
      this.state.objStoryData.key = lastIndex;
    }

    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
  }

  ClonefieldinArw = (key, wdtnm) => {
    //this.editorBackground();
    let rndCode = Math.floor(Math.random() * 1000);
    let _strData = JSON.stringify(this.state.cnf.tlsdtarr[key]);
    let obj = JSON.parse(_strData);
    this.state.objStoryData = obj;
    this.state.objStoryData.arrfled = 'copy of - ' + obj.arrfled;
    this.state.objStoryData.key = this.state.cnf.tlsdtarr.length; // tlsdtarr key value use for clone data
    if (wdtnm == 'job_board') {
      this.state.objStoryData._id = 'job_' + rndCode;
    } else if (wdtnm == 'tool_pricing') {
      this.state.objStoryData._id = 'pln_' + rndCode;
    } else {
      this.state.objStoryData._id = 'team_' + rndCode;
    }
    this.state.cnf.tlsdtarr.push(this.state.objStoryData);
    this.state.openCloseStoryData = true;
    this.setState(this.state);
  }

  deletefieldinArw = (key, arrName, childKey, name, subChildkey) => {
    let isDelete = true;
    // arrName==> only use for delete categoty array
    if (arrName == 'tlsctarr') {
      let ct_id = this.state.cnf.tlsctarr[key].ct_id;
      let _arrData = this.state.cnf.tlsdtarr.filter(x => x.ct_id == ct_id)[0];
      if (_arrData == undefined) {
        this.state.cnf.tlsctarr.splice(key, 1);
      } else {
        toast.error('You have reference data for this category');
        isDelete = false;
      }
    } else if (name == 'optn') {
      this.state.cnf.tlsdtarr[key].arradmr[childKey].optn.splice(subChildkey, 1);
    } else if (name == 'arradmr') {
      this.state.cnf.tlsdtarr[key].arradmr.splice(childKey, 1);
    } else {
      this.state.cnf.tlsdtarr.splice(key, 1);
    }

    if (!this.state.isEditWidget && isDelete) {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
  }

  AddfieldinChildArw = (name, key) => {
    if (name == 'tool_team_showcase') {
      this.state.objStoryData.arradmr.push({
        'icn': '',
        'url': ''
      });
    }

    //[S] for feedback widget
    if (name == 'feedback') {
      this.state.objStoryData.arradmr.push({
        'ilbl': true,
        'lbl': '',
        'typ': '',//textbox, radio button...
        'optn': [' '],
        'plchldr': '',
        'rtngclr': ''
      });
    }
    if (name == 'optn') {
      this.state.objStoryData.arradmr[key].optn.push('');
    }
    //[E] for feedback widget

    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
    this.setState(this.state);
  }
  //
  handleAddUpdateWidget = () => {
    if (this.state.objStoryData && this.state.objStoryData.arradmr && this.state.objStoryData.arradmr.length > 0) {
      const _arr = this.state.objStoryData; //this.state.cnf.tlsdtarr[i];
      for (let j = 0; j < _arr.arradmr.length; j++) {
        const _inpt = _arr.arradmr[j];
        if (document.getElementById('chklblEmty_' + j)) {
          if (!_inpt.lbl) {
            document.getElementById('chklblEmty_' + j).style.border = '2px solid red';
            return false;
          } else {
            document.getElementById('chklblEmty_' + j).style.border = '0px';
          }
        }
      }
    }
    let that = this;
    if (!that.widgetDataValidator.allValid()) {
      that.widgetDataValidator.showMessages();
      that.forceUpdate();
    }
    else {
      if (this.props.location.query.id) {
        this.handleUpdateCnf();
      } else {
        this.createWidget();
      }
      this.state.openCloseStoryData = false;
      localStorage.removeItem('W_FEED_SLIDE');
      this.setState(this.state);
    }
  }

  handleUpdateCnf = () => {
    if (this.state.cnf.tlstmdr) {
      this.state.cnf.tlstmdr = new Date(this.state.cnf.tlstmdr).getTime();
    }
    if (this.state.cnf.tlsdtarr && this.state.cnf.tlsdtarr.length > 0) {
      for (let i = 0; i < this.state.cnf.tlsdtarr.length; i++) {
        let _arrTls = this.state.cnf.tlsdtarr[i];
        if (_arrTls.strydt) {
          _arrTls.strydt = new Date(_arrTls.strydt);
        }
      }
    }

    let that = this;
    if (!that.postCardValidator.allValid()) {
      that.postCardValidator.showMessages();
      that.forceUpdate();
    } else {
      this.state.isEditWidget = false;
      localStorage.removeItem('W_WDGT_CRT');

      this.setState(this.state);
      let obj = {
        _id: this.props.location.query.id,
        cnf: this.state.cnf,
        htn: this.state.currLayoutId,
        htncrd: this.state.currCardId,
        htnpp: this.state.currHtnpp,
        wdsc: this.state.wdsc,
        ihwc: this.state.widgetById.ihwc,
        ihwi: this.state.widgetById.ihwi,
        mnrt: this.state.widgetById.mnrt,
        exkw: this.state.widgetById.exkw,
        inkw: this.state.widgetById.inkw,
        ifrmdtsndwbh: this.state.widgetById.ifrmdtsndwbh,
        frmdtwbhurl: this.state.widgetById.frmdtwbhurl,
        ifrmdtsndeml: this.state.widgetById.ifrmdtsndeml,
        frmdtsndemladd: this.state.widgetById.frmdtsndemladd,
        frmdtsndemlsbjct: this.state.widgetById.frmdtsndemlsbjct,
        frmdtsndemltmplt: this.state.widgetById.frmdtsndemltmplt,
        frmdtistrint: this.state.widgetById.frmdtistrint,
        dspltyp: this.state.widgetById.dspltyp,
        dabs: this.state.widgetById.dabs,
        irtnvstr: this.state.widgetById.irtnvstr,
        rtncnd: this.state.widgetById.rtncnd,
        iutmdspl: this.state.widgetById.iutmdspl,
        ibcks: this.state.widgetById.ibcks,
        irffrm: this.state.widgetById.irffrm,
        frmdt: this.state.widgetById.frmdt,
        expdt: this.state.widgetById.expdt,
        irptdy: this.state.widgetById.irptdy,
        arrptdy: this.state.widgetById.arrptdy,
        rptstm: this.state.widgetById.rptstm,
        rptetm: this.state.widgetById.rptetm,
        bhvtyp: this.state.widgetById.bhvtyp,
        dsplafttm: this.state.widgetById.dsplafttm,
        dsplaftscrl: this.state.widgetById.dsplaftscrl,
        dsplurl: this.state.widgetById.dsplurl,
        utmcnd: this.state.widgetById.utmcnd,
        bckscnd: this.state.widgetById.bckscnd,
        rfcnd: this.state.widgetById.rfcnd,
        unqid: this.state.widgetById.unqid,
      };
      this.props.updWidgetCnf(obj);
      setTimeout(() => {
        this.setTabIndex(this.state.tabIndex);
      }, 10);
    }
  }

  //get the previous changes
  handleCancelCnf = () => {
    let ihwc = this.state.widgetById.ihwc;
    let ihwi = this.state.widgetById.ihwi;
    let mnrt = this.state.widgetById.mnrt;
    let inkw = this.state.widgetById.inkw;
    let exkw = this.state.widgetById.exkw;
    this.state.isEditWidget = false;
    let colneData = JSON.parse(this.state.cloneWidgetById);
    this.state.cnf = colneData.cnf;
    this.state.widgetById = colneData;
    this.state.currLayoutId = colneData.htn;
    this.state.currCardId = colneData.htncrd;
    this.state.currHtnpp = colneData.htnpp;
    this.state.widgetById.ihwc = ihwc;
    this.state.widgetById.ihwi = ihwi;
    this.state.widgetById.mnrt = mnrt;
    this.state.widgetById.inkw = inkw;
    this.state.widgetById.exkw = exkw;
    this.setState(this.state);

    this.fnGetCardAndPopupList(this.state.currLayoutId, this.props.themeData);
  }

  //On click Exit button redirect to the previous page 
  handleWidgetCancel = () => {
    let obj = {
      wid: localStorage.getItem('WIDTP'),
      pvd: localStorage.getItem('pvd')
    };
    this.props.getWidgetByUser(obj);
    editType = this.props.location.query.wdtnm;

    if (this.state.isEdit == true) {
      browserHistory.goBack();
    }
    else {
      browserHistory.push('/widget/wdlist?ds=list');
    }

    //on cancel widget clear the old widget data in local storage
    localStorage.removeItem('W_WDGT_CRT');
    localStorage.removeItem('W_IS_RENDER');
    this.state.isEdit = false;
    this.state.isOpenIntegrationModel = false;
    this.state.openCloseWidget = false;
    this.setState(this.state);
  }

  /***********************pop-up**********************/
  updatePopupById = (popupId) => {
    if (!this.state.isEditWidget) {
      this.state.isEditWidget = true;
    }
    this.state.currHtnpp = popupId;
    this.setState(this.state);
  }


  /********************preview***********************/
  fnGetWidgetData = () => {
    let _arrDsi = [];
    if (this.state.widgetById && this.state.widgetById.dsi && this.state.widgetById.dsi.length > 0) {
      for (let i = 0; i < this.state.widgetById.dsi.length; i++) {
        let dsi = this.state.widgetById.dsi[i];
        _arrDsi.push({
          uid: dsi.uid,
          pid: dsi.pid,
          iin: dsi.iin,
          itwtrpls: dsi.itwtrpls,
          itwtpst: dsi.itwtpst,
          itwtrtwt: dsi.itwtrtwt
        });
      }
    }
    let obj = {
      arrDsi: _arrDsi,
      cn: this.props.location.query.cn,
      exkw: this.state.widgetById.exkw,
      inkw: this.state.widgetById.inkw,
      ihwc: this.state.widgetById.ihwc,
      ihwi: this.state.widgetById.ihwi,
      mnrt: this.state.widgetById.mnrt
    };
    this.props.getWidgetData(obj);
  }

  handleScreenSize = (type) => {
    if (type == 'desktop') {
      this.state.isMobileScreen = false;
      localStorage.setItem('W_RESPONSIVE', 'desktop');
    } else {
      this.state.isMobileScreen = true;
      localStorage.setItem('W_RESPONSIVE', 'mobile');
    }
    this.setState(this.state);
  }

  //reset widget changes
  confirmForResetWidget = () => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui confirm-alret-notidatamis'>
            <h1>Reset Wall</h1>
            <p>Are you sure want to apply default wall settings?</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default '
              onClick={() => { this.handleResetWidget(); onClose(); }}>
              Yes
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={() => onClose()}>
              No
            </button>
          </div>
        );
      }
    });
  }

  handleResetWidget = () => {
    let wid = this.props.location.query.wid;
    let obj = this.props.themeData.widget.filter(x => x._id == wid)[0];
    let objWid = JSON.stringify(obj);
    objWid = JSON.parse(objWid);
    this.state.wdsc = objWid.dn;
    let objWidget = objWid.config;
    objWidget.wdtnm = objWid.wn;

    ////original code 
    // objWidget.htn = objWid.htn;
    // objWid.htncrd ? objWidget.htncrd = objWid.htncrd : '';
    // objWid.htnpp ? objWidget.htnpp = objWid.htnpp : '';

    ////setting 
    objWidget.htn = this.state.currLayoutId;
    objWidget.htncrd = this.state.currCardId;
    objWidget.htnpp = this.state.currHtnpp;

    objWidget.cn = objWid.cn;
    objWidget.wid = wid;
    // this.state.cloneWidgetById = JSON.stringify(objWidget);
    if (this.state.cnf.tlsdtarr) objWidget.cnf.tlsdtarr = this.state.cnf.tlsdtarr;
    if (this.state.cnf.tlsctarr) objWidget.cnf.tlsctarr = this.state.cnf.tlsctarr;
    Object.assign(this.state.widgetById, objWidget);

    ////original code 
    // this.state.currLayoutId = objWid.htn;
    // objWid.htncrd ? this.state.currCardId = objWid.htncrd : '';
    // objWid.htnpp ? this.state.currHtnpp = objWid.htnpp : '';

    this.state.cnf = this.state.widgetById.cnf;
    this.state.isEditWidget = true;
    this.setState(this.state);

    //this.editorBackground();
  }
  /*******************Widget list code********************/

  openCloseWidgetPanel = (obj) => {
    this.state.openCloseWidget = !this.state.openCloseWidget;
    this.state.selectedWidget = obj;
    this.state.selectedWidgetList = [];
    this.state.usedQuota = 0;
    this.state.assignQuota = 0;
    //get user selectedWidget list    
    if (obj) {
      for (let i = 0; i < this.state.widgetListByUser.length; i++) {
        const u = this.state.widgetListByUser[i];
        if (u.wid == obj._id)
          this.state.selectedWidgetList.push(u);
      }
      //for get the used quota
      if (this.props.profile && this.props.profile.arpln != undefined) {
        this.props.profile.arpln.filter(x => {
          if (x.wmid == obj._id) {
            this.state.usedQuota = x.uuq;
            this.state.assignQuota = x.uaq;
          }
        });
      }
    }
    else {
      this.state.selectedWidget = '';
      this.state.selectedWidgetList = [];
    }
    this.setState(this.state);
  }

  openGetCodeModel = (obj) => {
    this.state.isOpenGetCodeModel = true;
    this.state.objWidget = obj;
    this.setState(this.state);

    //check user plan
    this.fnChkWidgetPlan(obj.wid, this.props.profile);
  }

  //for redirect the integration tab
  setIntName = () => {
    //localStorage.removeItem('W_TBINT');
    // if (this.props.location && this.props.location.query && this.props.location.query.id) {
    //   localStorage.setItem('W_TBINT', intName);
    //   this.state.isOpenGetCodeModel = false;
    //   this.setState(this.state);
    // } else {
    //   this.editWidget(this.state.objWidget);
    //   localStorage.setItem('W_TBINT', intName);
    //   this.state.isOpenGetCodeModel = false;
    //   this.setState(this.state);
    // }

    if (!this.props.location.query.id) {
      this.editWidget(this.state.objWidget);
    }
    this.state.tabIndex = 0;
    this.setTabIndex(0);
    this.state.isOpenGetCodeModel = false;
    this.setState(this.state);
  }

  installFBTab = () => {
    let currentURL = window.location.href.replace(/&/gi, '@');
    let objStateFB = {
      uk: this.props.profile._id,
      ti: this.props.profile.ti,
      uri: currentURL + '@tb=ds',
      path: window.location.pathname
    };
    localStorage.setItem('W_WDGT_CRT', JSON.stringify({
      wdsc: this.state.wdsc,
      widgetById: this.state.widgetById,
      currLayoutId: this.state.currLayoutId,
      currCardId: this.state.currCardId,
      currHtnpp: this.state.currHtnpp,
      isEditWidget: this.state.isEditWidget,
    }));
    let redirect_uri = process.env.REACT_APP_INT_API_URL;
    //let redirect_uri = 'https://sdtouoddgcxz.staqlab-tunnel.com/api';
    // // let authURL = 'https://www.facebook.com/v9.0/dialog/oauth?client_id=' +
    // //   process.env.REACT_APP_FB_APP_ID +
    // //   '&redirect_uri=' +
    // //   process.env.REACT_APP_INT_API_URL +
    // //   '/facebooktabs/oauth&scope=email,pages_show_list,public_profile,' +
    // //   'pages_read_engagement,pages_read_user_content&response_type=code&state=' +
    // //   JSON.stringify(objStateFB);
    let authURL = 'https://www.facebook.com/v9.0/dialog/oauth?client_id=' +
      process.env.REACT_APP_FB_APP_ID +
      '&redirect_uri=' + redirect_uri +
      '/facebooktab/oauth&scope=email,pages_show_list,public_profile,pages_read_engagement,' +
      'pages_read_user_content&response_type=code&state=' + JSON.stringify(objStateFB);
    window.open(authURL, '_self');
  }

  handleGetCodeTabClick = (tabName) => {
    this.state.getCodeTabName = tabName;
    this.setState(this.state);
  }

  getCodeModelCont = () => {
    let _IframeURL;
    let _brandURL;
    let _IframeHostURL;
    let divTag;
    let _shareURL;
    let _Iframe;
    if (this.props.profile && this.props.profile.brand && this.props.profile.brand.wurl) {
      let _brandName = this.props.profile.brand.bn || 'Wall';
      _IframeURL = 'http://127.0.0.1:1235/iframe.html';
      _brandURL = 'https://' + this.props.profile.brand.wurl || 'https://pt.wisernotify.com';
      _IframeHostURL = 'https://' + this.props.profile.brand.wurl + '/socialwall/iframe.html';
      divTag = '<script>!function () { if (window.t4hto3e) console.log("' + _brandName + ' pixel installed multiple time in this page"); else { window.t4hto3e = !0; var t = document, e = window, n = function () { var e = t.createElement("script"); e.type = "text/javascript", e.async = !0, e.src = "' + _brandURL + '/widget.js?ti=' + this.state.objWidget.ti + '&t=" + Date.now(), document.body.appendChild(e) }; "complete" === t.readyState ? n() : window.attachEvent ? e.attachEvent("onload", n) : e.addEventListener("load", n, !1) } }();</script>\n<div id="widget_' + this.state.objWidget._id + '" class="wIs3rwidG3t widget_' + this.state.objWidget._id + '" data-wm="' + this.state.objWidget.wid + '" data-id="' + this.state.objWidget.unqid + '"></div> ';
      _shareURL = _IframeURL + '?id=widget_' + this.state.objWidget._id + '&wm=' + this.state.objWidget.wid + '&unqid=' + this.state.objWidget.unqid + '&ti=' + this.state.objWidget.ti + '';
      //for iframe
      _Iframe = '<iframe src="' + _IframeHostURL + '?id=widget_' + this.state.objWidget._id + '&wm=' + this.state.objWidget.wid + '&unqid=' + this.state.objWidget.unqid + '&ti=' + this.state.objWidget.ti + '" frameborder="0" height="500" width="1000"></iframe>';
    }
    else {
      _IframeURL = 'http://127.0.0.1:1235/iframe.html';
      _brandURL = 'https://pt.wisernotify.com';
      _IframeHostURL = 'https://pt.wisernotify.com/socialwall/iframe.html';
      divTag = '<script>!function () { if (window.t4hto3e) console.log("Wall pixel installed multiple time in this page"); else { window.t4hto3e = !0; var t = document, e = window, n = function () { var e = t.createElement("script"); e.type = "text/javascript", e.async = !0, e.src = "' + _brandURL + '/widget.js?ti=' + this.state.objWidget.ti + '&t=" + Date.now(), document.body.appendChild(e) }; "complete" === t.readyState ? n() : window.attachEvent ? e.attachEvent("onload", n) : e.addEventListener("load", n, !1) } }();</script>\n<div id="widget_' + this.state.objWidget._id + '" class="wIs3rwidG3t widget_' + this.state.objWidget._id + '" data-wm="' + this.state.objWidget.wid + '" data-id="' + this.state.objWidget.unqid + '"></div> ';
      _shareURL = _IframeURL + '?id=widget_' + this.state.objWidget._id + '&wm=' + this.state.objWidget.wid + '&unqid=' + this.state.objWidget.unqid + '&ti=' + this.state.objWidget.ti + '';
      //for iframe
      _Iframe = '<iframe src="' + _IframeHostURL + '?id=widget_' + this.state.objWidget._id + '&wm=' + this.state.objWidget.wid + '&unqid=' + this.state.objWidget.unqid + '&ti=' + this.state.objWidget.ti + '" frameborder="0" height="500" width="1000"></iframe>';
    }

    let divId = 'copy-div' + this.state.objWidget._id;

    if (this.state.objWidget && this.state.objWidget.dsi && this.state.objWidget.dsi.length > 0) {
      this.state.objWidget.isCreateInt = true;
    }
    // let widget_mst_name = '';
    // if (this.state.widgetList && this.state.objWidget) {
    //   widget_mst_name = this.state.widgetList.filter(x => x._id == this.state.objWidget.wid)[0].dn;
    // }
    return (
      // this.state.isPlnPurchase ?
      <div className="getcodecontent">
        <GetCodeCard
          divTag={divTag}
          divId={divId}
          _Iframe={_Iframe}
          _shareURL={_shareURL}
          objWidget={this.state.objWidget}
          state={this.state}
          rdtShpPage={this.rdtShpPage}
          deleteWidgetDiv={this.deleteWidgetDiv}
          copyWidgetDiv={this.copyWidgetDiv}
          installFBTab={this.installFBTab}
          handleInputchange={this.handleInputchange}
          getShpThemeList={this.getShpThemeList}
          handleGetCodeTabClick={this.handleGetCodeTabClick}
          getCodeTabName={this.state.getCodeTabName}
          setIntName={this.setIntName}
          widgetByIdDsi={this.state.objWidget.dsi} />
      </div>
      // :
      // this.state.objWidget ?
      //   <div className="planmodalcontent">
      //     <Plan
      //       objwidget={this.state.objWidget}
      //       widget_mst_name={widget_mst_name} />
      //   </div>
      //   :
      //   ''
    );
  }

  closeGetCodeModel = () => {
    this.state.isOpenGetCodeModel = false;
    this.state.objWidget = '';
    this.setState(this.state);
  }

  //on click quota refresh btn get latest quota uses
  getLatestQuotaUses = () => {
    //for loader 
    this.state.usedQuota = '-';
    this.setState(this.state);

    this.props.getProfile();
  }

  //Add the widget div in shopify
  addShpWidgetDiv = () => {
    let isAddShpDiv = true;
    if (this.state.objWidget.shfyatinstlarr && this.state.objWidget.shfyatinstlarr.length > 0) {
      this.state.objWidget.shfyatinstlarr.filter(x => {
        if (x.pgnm == this.state.pgnm && this.state.thmid.toString() == x.thmid) {
          toast.error('Same page name with same theme not allow');
          isAddShpDiv = false;
        }
      });
    }
    if (isAddShpDiv) {
      let shpDiv = '<div id="widget_' + this.state.objWidget._id + '" class="wIs3rwidG3t" data-wm="' + this.state.objWidget.wid + '" data-id="' + this.state.objWidget.unqid + '"></div>';
      let obj = {
        widgetId: this.state.objWidget._id,
        div: shpDiv,
        shop: localStorage.getItem('WIDSHP'),
        token: this.state.shpToken,
        pgnm: this.state.pgnm,
        pstn: this.state.pstn,
        thmid: this.state.thmid,
        thmnm: this.state.thmnm
      };
      //this.closeGetCodeModel();   
      this.props.addShpWidgetDiv(obj);

      //for display loader
      this.state.objWidget.shfyatinstlarr = '';
      this.setState(this.state);
    }
  }

  //get the latest theme list from shopify
  getShpThemeList = () => {
    this.state.ThemeOption = [];
    this.setState(this.state);
    let obj = {
      shp: localStorage.getItem('WIDSHP'),
      token: this.state.shpToken,
      wdgtp: localStorage.getItem('WIDNM')
    };
    this.props.getShpThemeList(obj);
  }

  //Redirect the shopify page 
  rdtShpPage = (obj) => {
    let _arrPage = [
      { pg: 'all', val: 'layout/theme.liquid' },
      { pg: 'home', val: 'templates/index.liquid' },
      { pg: 'product', val: 'templates/product.liquid' },
      { pg: 'collection', val: 'templates/collection.liquid' },
      { pg: 'blog', val: 'templates/blog.liquid' },
    ];
    let pgName = _arrPage.filter(x => x.pg == obj.pgnm)[0].val;
    window.open('https://' + localStorage.getItem('WIDSHP') + '/admin/themes/' + obj.thmid + '?key=' + pgName);
  }

  deleteWidgetDiv = (obj) => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>Confirmation</h1>
            <p>Are you sure to delete this recode?</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
              onClick={() => { this.deleteShpWidgetDiv(obj), onClose(); }}>
              Yes
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              No
            </button>
          </div>
        );
      }
    });
  }

  //delete the widget div from shopify
  deleteShpWidgetDiv = (obj) => {
    let shpDiv = '<div id="widget_' + this.state.objWidget._id + '" class="wIs3rwidG3t" data-wm="' + this.state.objWidget.wid + '" data-id="' + this.state.objWidget.unqid + '"></div>';
    let shpObj = {
      divId: obj._id,
      widgetId: this.state.objWidget._id,
      shop: localStorage.getItem('WIDSHP'),
      thmid: obj.thmid,
      token: this.state.shpToken,
      div: shpDiv,
      pgnm: obj.pgnm
    };
    this.props.deleteShpWidgetDiv(shpObj);

    //for display loader
    this.state.objWidget.shfyatinstlarr = '';
    this.setState(this.state);
  }

  changeWidgetStatus = (obj, type, val) => {
    let newIa = obj.ia;
    if (type === 'ia') {
      newIa = val;
    }
    let data = {
      _id: obj._id,
      ia: newIa,
      addonqty: this.props.profile.addonqty,
      togl: true
    };
    for (let i = 0; i < this.state.widgetListByUser.length; i++) {
      if (this.state.widgetListByUser[i]._id == obj._id) {
        this.state.widgetListByUser[i].ia = newIa;
        this.state.widgetListByUser[i].udt = new Date();
      }
    }
    this.setState(this.state);
    this.props.updWidgetStatus(data);
    this.getWidgetStatusCount();
  }


  //open modal for clone theme
  openCloneThemeModal = (wid, wdsc) => {
    this.state.cloneWid = wid;
    this.state.cloneWn = wdsc;
    this.state.openCloseCloneModal = true;
    this.setState(this.state);
  }

  cloneThemeModelCont = () => {
    return (
      <div className="modal-body">
        <div className="modal-new-noti-body">
          <div className="wg-clone-content">
            <div className="addnoti-inblock">
              <div className="nf-samenoti-form">
                <div className="nf-group-input">
                  <label>Write new Wall name</label>
                  <ReactTooltip id='clone_name' aria-haspopup='true' role='example'>
                    <p>Write Wall name that easy to remember.</p>
                  </ReactTooltip>
                  <input onChange={(e) => this.handleInputchange('widgetName', e.target.value)}
                    type="text" name="themename" className="nf-input nf-input-sm" value={this.state.widgetName} placeholder="Wall Name" />
                  {this.cloneWidgetValidator.message('Wall name', this.state.widgetName, 'required')}
                </div>
                <div className="text-center">
                  <button type='button' className="nf-btn nf-btn-default nf-btn-noneBdr nf-btn-min15x nf-btn-minW" onClick={() => this.createCloneWidget()}>
                    Create clone
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  createCloneWidget = () => {
    let that = this;
    if (!that.cloneWidgetValidator.allValid()) {
      that.cloneWidgetValidator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        cloneWid: this.state.cloneWid,
        wdsc: this.state.widgetName,
        addonqty: this.props.profile.addonqty
      };
      this.props.createCloneWidget(obj);
      this.closeCloneThemeModal();
      this.openCloseWidgetPanel();
    }
  }

  closeCloneThemeModal = () => {
    this.state.cloneWid = '';
    this.state.cloneWn = '';
    this.state.openCloseCloneModal = false;
    this.setState(this.state);
  }


  //in widget list edit the widget
  editWidget = (obj) => {
    localStorage.setItem('W_FOR_MASONRY', 'widget_repons');
    // browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?wid=' + obj.wid + '&id=' + obj._id + '&cn=' + obj.cn + '&wdtnm=' + obj.wdtnm);
    this.props.getWidgetById(obj._id);
    let widobj = {
      wallId: obj._id,
      cn: obj.cn
    };
    this.props.getWidgetData(widobj);
    this.state._isCallTheme = true;
    this.setState(this.state);
    setTimeout(() => {
      localStorage.removeItem('W_FOR_MASONRY');
    }, 2000);
    // this.openCloseWidgetPanel();

    if (obj.wdtnm == 'back_to_top') {
      this.state.iconscout = 'top';
    } else {
      this.state.iconscout = '';
    }
    this.state.tabIndex = 0;
    this.state.isEdit = true;
    this.setState(this.state);
    this.searchIconscout();
  }

  copyWidgetDiv = (div, e) => {
    if (e) {
      e.target.select();
    }
    copy(div, { debug: true });
    // let toastDiv = document.getElementById(id);
    // toastDiv.className = 'copy-script-upbg click-to-copy';
    // setTimeout(() => {
    //   toastDiv.className = 'copy-script-upbg';
    // }, 5000);
    if (!toast.isActive(this.toastId)) {
      this.toastId = toast.success('Your Wall code is copied.');
    }
  };

  deleteWidget = (objWidget) => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>Confirmation</h1>
            <p>Are you sure to delete this Wall?</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
              onClick={() => { this.deleteUserWidget(objWidget), onClose(); }}>
              Yes
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              No
            </button>
          </div>
        );
      }
    });
  }

  //delete User widget
  deleteUserWidget = (objWidget) => {
    let obj = {
      id: objWidget._id,
      unqid: objWidget.unqid,
      cn: objWidget.cn
    };
    this.props.delUserWidget(obj);

    //remove from user all widget list
    let _index = this.state.widgetListByUser.findIndex(x => x._id == objWidget._id);
    var array = this.state.widgetListByUser;
    if (_index > -1) {
      array.splice(_index, 1);
    }
    this.state.widgetListByUser = array;
    if (array.length == 0) { userWidgetList = []; }
    this.setState(this.state);

    //remove from selected widget list
    let i = this.state.selectedWidgetList.findIndex(x => x._id == objWidget._id);
    var a = this.state.selectedWidgetList;
    if (i > -1) {
      a.splice(i, 1);
    }
    this.state.selectedWidgetList = a;
    //if deleted widget is last than close sidebar and remove block
    if (this.state.selectedWidgetList.length == 0) this.openCloseWidgetPanel();
    this.setState(this.state);
    this.getWidgetStatusCount();
  }

  //getWidgetStatusCount
  getWidgetStatusCount = () => {
    userWidgetList.filter(x => {
      let active = 0;
      let total = 0;
      this.state.widgetListByUser.filter(z => {
        if (x._id == z.wid) {
          if (z.ia == true) { active = active + 1; }
          total = total + 1;
        }
      });
      x.ia = active;
      x.total = total;
    });
  }

  widgetListfilterByUser = (type) => {
    if (type == 'all') {
      this.state.createdWidgetList = userWidgetList;
      this.setState(this.state);
    }
    else {
      let _arr = [];
      userWidgetList && userWidgetList.filter(x => {
        if (x.cn == type) {
          _arr.push(x);
        }
      });
      this.state.createdWidgetList = _arr;
      this.setState(this.state);
    }
  }

  handleWidgetListTabChange = (index) => {
    this.state.WidgetListIndex = index;
    this.setState();
  }

  /**************************[S] Widget Analytic******************************/
  openCloseAnalyticModel = (w) => {
    this.state.isOpenAnalyticModel = !this.state.isOpenAnalyticModel;
    if (this.state.isOpenAnalyticModel) {
      this.state.selectWidget = w.wdsc;
      this.props.getAnalytic(w._id);
    } else {
      this.state.selectWidget = '';
    }
    this.setState(this.state);
  }

  analyticModelCont = () => {
    return (
      <AnalyticCard
        selectedWidget={this.state.selectedWidget}
        ttlImpcnt={this.state.ttlImpcnt}
        arrWidgetDt={this.state.arrWidgetDt}
        arrWidgetCnt={this.state.arrWidgetCnt}
        selectWidget={this.state.selectWidget} />
    );
  }


  /**************************[E] Widget Analytic******************************/
  //open close model for hire us
  openCloseHireusModel = () => {
    this.state.isOpenHireusModel = !this.state.isOpenHireusModel;
    this.setState(this.state);
  }

  //hire us model content
  hireusModelCont = () => {
    return (
      <div className="modal-body-content modal-hire-content">
        <div className="col-sm-12 col-xs-12 ph-0 ">
          <div className="hire-block-title">Our technical expert team will help you to implement  pixel code on your website.</div>
          <div className="nf-group-input">
            <label >Website URL</label>
            <div className="line-input-btn">
              <input type="text" className="nf-input nf-input-sm" value={this.state.wurl} onChange={(e) => this.handleInputchange('wurl', e.target.value)} />
              {this.hireValidator.message('website url', this.state.wurl, 'required')}
            </div>
          </div>
          <div className="nf-group-input">
            <label>Website platform</label>
            <div className="">
              <Dropdown className="nf-select-dropdown nf-select-defaultdd  nf-select-conditondd" options={optnPlatform} value={this.state.wplt} onChange={(e) => this.handleInputchange('wplt', e.value)} />
              {this.hireValidator.message('website platform', this.state.wplt, 'required')}
            </div>
          </div>
          {
            this.state.wplt == 'other' &&
            <div className="nf-group-input">
              <label> Enter website platform </label>
              <div className="line-input-btn">
                <input type="text" className="nf-input nf-input-sm" value={this.state.oth} onChange={(e) => this.handleInputchange('oth', e.target.value)} />
                {this.hireValidator.message('website platform', this.state.oth, 'required')}
              </div>
            </div>
          }
          <div className="nf-group-input">
            <label> Your email </label>
            <div className="line-input-btn">
              <input className="nf-input nf-input-sm" type="email" value={this.state.he} onChange={(e) => this.handleInputchange('he', e.target.value)} />
              {this.hireValidator.message('email', this.state.he, 'required|email')}
            </div>
          </div>
          <div className="nf-group-input">
            <label>Remark</label>
            <div className="line-input-btn">
              <textarea className="nf-textarea" rows="3" value={this.state.rmk} onChange={(e) => this.handleInputchange('rmk', e.target.value)} />
            </div>
          </div>
        </div>
        <button type="button" className="nf-btn nf-btn-default nf-btn-minW" onClick={() => this.createHireUs()}>Submit</button>
      </div>
    );
  }

  //on click hireus btn call this function
  createHireUs = () => {
    let that = this;
    if (!that.hireValidator.allValid()) {
      that.hireValidator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        wurl: this.state.wurl,
        wplt: this.state.wplt,
        e: this.state.he,
        rmk: this.state.rmk,
        re: this.props.profile.e
      };
      if (this.state.wplt == 'other') {
        obj.wplt = this.state.oth;
      }
      let _url = this.state.wurl.split('.');
      if (_url.length < 2) {
        toast.error('please enter valid website Url');
        return false;
      }
      this.props.createHireUs(obj);
      this.state.wurl = '';
      this.state.wplt = 'bigCommerce';
      this.state.he = this.props.profile.e;
      this.state.rmk = '';
      this.state.oth = '';
      this.state.isOpenHireusModel = false;
      this.setState(this.state);
    }
  }

  //for edit the goal name
  handelWidgetNameEdit = (nameDiv, editDiv, editInput, value) => {
    document.getElementById(nameDiv).style.display = 'none';
    document.getElementById(editDiv).style.display = 'block';
    document.getElementById(editInput).value = value;
  };

  //for update the goal name
  handleWidgetNameSave = (nameDiv, editDiv, editInput, value, wid) => {
    let newName = document.getElementById(editInput).value;
    if (newName !== '') {
      if (value !== newName) {
        for (let i = 0; i < this.props.userWidget.length; i++) {
          let widget = this.props.userWidget[i];
          if (widget._id == wid) {
            widget.wdsc = newName;
            widget.udt = new Date();
          }
        }
        let obj = {
          _id: wid,
          wdsc: newName
        };
        this.props.updWidgetName(obj);
        ///  this.setState(this.state);
      }

      document.getElementById(nameDiv).style.display = 'block';
      document.getElementById(editDiv).style.display = 'none';
    }
  };

  handelwidgetNameClose = (nameDiv, editDiv) => {
    document.getElementById(nameDiv).style.display = 'block';
    document.getElementById(editDiv).style.display = 'none';
  };

  //set loader true/false for datasource
  handleIsLoader = () => {
    this.state.isLoaderDS = !this.state.isLoaderDS;
    this.setState(this.state);
  }

  setTabIndex = (index) => {
    this.state.tabIndex = index;
    this.setState(this.state);
    let menuInterval = setInterval(() => {
      if (document.getElementById('Wdgt_Edit_sidebar_Blk')) {
        document.getElementById('Wdgt_Edit_sidebar_Blk').style.cssText += 'transform: translate(0px, ' + (index * 90) + 'px);';
        clearInterval(menuInterval);
      }
    }, (1));
  }

  setIntTabIndex = (index) => {
    this.state.intTabIndex = index;
    this.setState(this.state);

    let tabWidth = 100;
    let tabtrans = 48;

    if (index == 0) {
      tabWidth = 100;
      tabtrans = 48;
    } else if (index == 1) {
      tabWidth = 65;
      tabtrans = 219;
    }
    if (document.getElementById('Wdgt_Intg_sidebar_Blk')) {
      document.getElementById('Wdgt_Intg_sidebar_Blk').style.cssText += 'transform: translate(' + tabtrans + 'px, 0px); width:' + tabWidth + 'px;';
    }
  }

  handleTabClick = (tabName) => {
    if (tabName === 'display_rule' || tabName === 'data_collect' || tabName === 'automation') {
      localStorage.setItem('W_IS_RENDER', false);
    } else {
      localStorage.removeItem('W_IS_RENDER');
    }

    //
    if (tabName === 'automation') {
      //check user plan
      this.fnChkWidgetPlan(this.props.location.query.wid, this.props.profile);
    }
  }

  handleCancelSchedule = () => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>Confirmation</h1>
            <p>Are you sure to cancel schedule?</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
              onClick={() => { this.cancelAutomationSchedule(), onClose(); }}>
              Yes
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>
              No
            </button>
          </div>
        );
      }
    });
  }


  cancelAutomationSchedule = async () => {
    const authToken = localStorage.getItem('authToken');
    const token = authToken ? authToken : null;
    await fetch('https://us-east1-wiserwall.cloudfunctions.net/Automation_Trigger/api/custom/clearAll?id=' + this.state.widgetById._id, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(res => res.json()).then((res) => {
      console.log(res, 'res res');
    });
  }

  //handle appearance tab, change event
  handleTabchange = (tabName, cardName, crdclkact) => {
    if (cardName == 'appearance') {
      let tabWidth = 75;
      let tabtrans = 16;
      if (tabName == 'layout' && (crdclkact != '2' || !this.fnCheckFieldIsDisplayOrNot('cnf.crdclkact', currLayout))) {
        tabWidth = 75;
        tabtrans = 66;
      } else if (tabName == 'layout') {
        tabWidth = 75;
        tabtrans = 16;
      } else if (tabName == 'card' && (crdclkact != '2' || !this.fnCheckFieldIsDisplayOrNot('cnf.crdclkact', currLayout))) {
        tabWidth = 65;
        tabtrans = 200;
      } else if (tabName == 'card') {
        tabWidth = 52;
        tabtrans = 140;
      } else if (tabName == 'popup') {
        tabWidth = 72;
        tabtrans = 243;
      }
      if (document.getElementById('Wdgt-Tab-appearance')) {
        document.getElementById('Wdgt-Tab-appearance').style.cssText += 'transform: translate(' + tabtrans + 'px, 0px); width:' + tabWidth + 'px;';
      }
    } else {
      let tabWidth = 75;
      let tabtrans = 16;
      if (tabName == 'display') {
        tabWidth = 75;
        tabtrans = 16;
      } else if (tabName == 'segmentation') {
        tabWidth = 120;
        tabtrans = 95;
      } else if (tabName == 'behaviour') {
        tabWidth = 90;
        tabtrans = 220;
      }
      if (document.getElementById('Wdgt-Tab-displayRule')) {
        document.getElementById('Wdgt-Tab-displayRule').style.cssText += 'transform: translate(' + tabtrans + 'px, 0px); width:' + tabWidth + 'px;';
      }
    }
  }

  //haandle  widget tab click event {create widget, widget list}
  handleWidgetTabClick = (index) => {
    let tabWidth = 120;
    let tabtrans = 0;

    if (index == 0) {
      tabWidth = 120;
      tabtrans = 0;
    } else if (index == 1) {
      tabWidth = 80;
      tabtrans = 124;
    } else if (index == 2) {
      tabWidth = 96;
      tabtrans = 208;
    } else if (index == 3) {
      tabWidth = 138;
      tabtrans = 308;
    } else if (index == 4) {
      tabWidth = 104;
      tabtrans = 452;
    } else if (index == 5) {
      tabWidth = 73;
      tabtrans = 562;
    }
    return ({ tabWidth, tabtrans });
  }

  // //open plan info model
  // openPlanModel = (val) => {
  //   this.state.planWidget = val;
  //   this.state.isOpenPlanModel = true;
  //   this.setState(this.state);
  // }

  // closePlanInfoModel = () => {
  //   this.state.planWidget = '';
  //   this.state.isOpenPlanModel = false;
  //   this.setState(this.state);
  // }

  // //display plan info model
  // displayPlanInfo = () => {
  //   let widget_mst_name = this.state.planWidget.dn;
  //   let planInfo = {
  //     wdtnm: this.state.planWidget.wn,
  //     wid: this.state.planWidget._id
  //   };
  //   return (
  //     this.authToken ?
  //       <Plan
  //         objwidget={planInfo}
  //         widget_mst_name={widget_mst_name} />
  //       : ''
  //   );
  // }

  isOpenIntegrationModel = () => {
    this.state.isOpenIntegrationModel = !this.state.isOpenIntegrationModel;
    if (this.state.isOpenIntegrationModel == false) {
      this.state.usIntObj = {};
      this.setState(this.state);
      this.props.getActiveIntgList();
    }
    this.setState(this.state);
  }

  //onclick open side panel for view review data
  viewReviewData = (objUsInt, pgObj) => {
    this.state.isOpenIntegrationModel = !this.state.isOpenIntegrationModel;
    this.state.usIntObj = objUsInt;
    this.state.usIntObj.pgObj = pgObj;
    this.state.usIntObj.filData = pgObj;
    localStorage.setItem('W_DIR_TBINT', this.state.usIntObj.inm);
    // console.log(this.state.isOpenViewReviewModel);
    this.setState(this.state);
  }

  redirectPreview = () => {
    let _url = 'https://wisernotify.com/preview/?id=widget_' + this.state.widgetById._id + '&wm=' + this.state.widgetById.wid + '&unqid=' + this.state.widgetById.unqid + '&ti=' + this.state.widgetById.ti;

    try {
      let tracker = window.ga.getAll()[0];
      tracker.send('event', 'Product Button Click', 'Preview_Wall', this.props.profile.e, { transport: 'beacon' });
    } catch (error) {
      console.log(error);
    }
    window.open(_url);
  }


  // instafeed code from here 
  createInstaFeedURL = () => {
    let obj = {
      wid: this.props.location.query.wid,
      id: this.props.location.query.id,
      cn: this.props.location.query.cn,
      wdtnm: this.props.location.query.wdtnm
    };
    this.state.instaLoad = false;
    this.setState(this.state);
    this.props.createInstaFeedURL(obj);
  }

  //open close model for hire us
  openCloseInstaFeedModel = () => {
    this.state.isOpenInstaFeedModel = !this.state.isOpenInstaFeedModel;
    this.setState(this.state);
  }

  handleUpgradePlan = () => {
    this.openCloseInstaFeedModel();
  }

  //instafeed popup
  instaFeedModel = () => {
    return (
      <div className="modal-body-content modal-insta-feed">
        <img src={insta} alt="Instagram" />
        <h2>Instagram feed</h2>
        <p>The Instagram Feed feature is available for free with the default configuration. However, if you wish to modify the configuration to meet your specific requirements, you can subscribe to our premium <span>plan for just $5 per month.</span></p>
        <button type="button" className="nf-btn nf-btn-default insta-btns" onClick={() => this.instaFeedPaymant()}>Continue</button>
        <button type="button" className="nf-btn nf-btn-default insta-btns nf-brder" onClick={() => this.openCloseInstaFeedModel()}>Use Free</button>
        <ul className='insta-feed-ul'>
          <li><span>5 layouts</span></li>
          <li><span>3 card designs</span></li>
          <li><span>2 popup designs</span></li>
          <li><span>Fully customizable theme</span></li>
        </ul>
      </div>
    );
  }

  instaFeedPaymant = () => {
    let obj = {
      wid: this.props.location.query.wid,
      id: this.props.location.query.id,
      cn: this.props.location.query.cn,
      wdtnm: this.props.location.query.wdtnm
    };
    this.props.instaFeedPaymant(obj);
  }

  render() {
    let widgetByIdForInt = this.state.widgetById;
    this.postCardValidator.purgeFields();
    this.widgetDataValidator.purgeFields();
    const currCategory = this.props.location.query.cn;
    let arrDataSource = [];
    if (this.state.lstActiveIntg) {
      let dsiData = [];
      if (widgetByIdForInt && widgetByIdForInt.dsi && widgetByIdForInt.dsi.length > 0) {
        dsiData = widgetByIdForInt.dsi;
      }
      // else if (this.props.widgetById && this.props.widgetById.dsi && this.props.widgetById.dsi.length > 0) {
      //   dsiData = this.props.widgetById.dsi;
      // }
      this.state.lstActiveIntg.filter(intg => {
        intg.items.filter(item => {
          if (dsiData && dsiData.length > 0) {
            dsiData.filter(dsi => {
              if (dsi.uid == item._id) {
                arrDataSource.push({
                  uid: dsi.uid,
                  pid: dsi.pid,
                  rmk: dsi.rmk,
                  iin: dsi.iin
                });
              }
            });
          }
        });
      });
    }
    //get current select layout from layout list    
    if (this.state.currLayoutId && this.props.themeData && this.props.themeData.layout) {
      currLayout = this.props.themeData.layout.filter(x => x._id == this.state.currLayoutId)[0];
    }
    //get current select card from card list
    if (this.state.currCardId && this.props.themeData && this.props.themeData.card) {
      currCard = this.props.themeData.card.filter(x => x._id == this.state.currCardId)[0];
    }
    //get current select pop up from popup list
    if (this.state.currHtnpp && this.props.themeData && this.props.themeData.popup) {
      currPopup = this.props.themeData.popup.filter(x => x._id == this.state.currHtnpp)[0];
    }
    return (
      <div className="page-wrapper page-editor">
        {
          this.props.location.query.wid ?
            <div className="wdgt-editor-content animate__fadeInUp">

              {
                localStorage.getItem('userTyp') == 'instafeed' ?
                  <InstafeedHeader
                    handleWidgetCancel={this.handleWidgetCancel}
                    openGetCodeModel={this.openGetCodeModel}
                    profile={this.props.profile}
                    authToken={this.authToken}
                    handleCancelCnf={this.handleCancelCnf}
                    handleUpdateCnf={this.handleUpdateCnf}
                    createWidget={this.createWidget}
                    handleInputchange={this.handleInputchange}
                    handleScreenSize={this.handleScreenSize}
                    redirectPreview={this.redirectPreview}
                    wdtLoginCreateWidget={this.wdtLoginCreateWidget}
                    confirmForResetWidget={this.confirmForResetWidget}
                    widgetId={this.props.location.query.id}
                    state={this.state}
                  />
                  :
                  <WidgetHeader
                    handleWidgetCancel={this.handleWidgetCancel}
                    openGetCodeModel={this.openGetCodeModel}
                    profile={this.props.profile}
                    authToken={this.authToken}
                    handleCancelCnf={this.handleCancelCnf}
                    handleUpdateCnf={this.handleUpdateCnf}
                    createWidget={this.createWidget}
                    handleInputchange={this.handleInputchange}
                    handleScreenSize={this.handleScreenSize}
                    redirectPreview={this.redirectPreview}
                    wdtLoginCreateWidget={this.wdtLoginCreateWidget}
                    confirmForResetWidget={this.confirmForResetWidget}
                    widgetId={this.props.location.query.id}
                    state={this.state}
                  />
              }

              {!this.props.loading ?
                <div className="wdgt-editor-fullview">
                  <aside className="sidebar-block">
                    <Tabs className="nf-default-tabs default-tabs-vrtl default-tabs-sidebar" selectedIndex={this.state.tabIndex} onSelect={index => this.setTabIndex(index)}>
                      <TabList>
                        {/*Layout Card */}
                        <li className="sidebar-ani-block" id='Wdgt_Edit_sidebar_Blk'></li>
                        {/* Data-Set */}
                        {(currCategory == 'review' ||
                          currCategory == 'social' ||
                          this.props.location.query.wdtnm == 'story_widget' ||
                          this.props.location.query.wdtnm == 'job_board' ||
                          this.props.location.query.wdtnm == 'tool_slider' ||
                          this.props.location.query.wdtnm == 'faq' ||
                          this.props.location.query.wdtnm == 'automation_marketing' ||
                          this.props.location.query.wdtnm == 'feedback' ||
                          this.props.location.query.wdtnm == 'tool_restaurant' ||
                          this.props.location.query.wdtnm == 'tool_team_showcase' ||
                          this.props.location.query.wdtnm == 'tool_youtube_gallery' ||
                          this.props.location.query.wdtnm == 'tool_pricing' ||
                          this.props.location.query.wdtnm == 'tool_number_animation') && this.authToken &&
                          <Tab onClick={() => this.handleTabClick('data_set')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16">
                              <path id="Path_20880" data-name="Path 20880" d="M-410.326,58.3c-4.216,0-7.365,1.579-7.484,3.757V70.48c0,2.179,3.218,3.822,7.484,3.822,4.286,0,7.516-1.644,7.516-3.822V62.055C-402.952,59.881-406.113,58.3-410.326,58.3Zm5.836,8.023c0,1.073-2.5,2.272-5.844,2.272-3.317,0-5.8-1.2-5.8-2.272V64.56a10.98,10.98,0,0,0,5.41,1.4h.831a11.067,11.067,0,0,0,5.4-1.394Zm-5.836-1.928c-3.322,0-5.8-1.2-5.8-2.273,0-.517.61-1.081,1.63-1.505a11.165,11.165,0,0,1,4.175-.729c3.34,0,5.836,1.18,5.836,2.235C-404.489,63.2-406.986,64.4-410.326,64.4Zm-5.8,4.37a11.05,11.05,0,0,0,5.415,1.388h.825a11.067,11.067,0,0,0,5.4-1.394v1.72c0,1.073-2.481,2.309-5.821,2.309h-.071c-3.295-.05-5.749-1.254-5.749-2.309Z" transform="translate(417.81 -58.302)" fill="#8392a5" />
                            </svg>
                            <h6 className="side-editor-icon">Data Source</h6>
                          </Tab>
                        }
                        <Tab onClick={() => this.handleTabClick('layout')}> {/* () => { this.editorBackground(); this.handleTabClick('layout'); }*/}
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16.001" viewBox="0 0 16 16.001">
                            <path id="Path_20879" data-name="Path 20879" d="M-655.6,102.31h-14a1,1,0,0,1-1-1v-14a1,1,0,0,1,1-1h14a1,1,0,0,1,1,1v14A1,1,0,0,1-655.6,102.31Zm-10.08-14.753h-3.672v3.669h3.672Zm0,4.916h-3.672v3.671h3.672Zm0,4.919h-3.672v3.671h3.672Zm4.917-9.835h-3.669v3.669h3.669Zm0,4.916h-3.669v3.671h3.669Zm0,4.919h-3.669v3.671h3.669Zm4.919-9.835h-3.671v3.669h3.671Zm0,4.916h-3.671v3.671h3.671Zm0,4.919h-3.671v3.671h3.671Z" transform="translate(670.594 -86.309)" fill="#8392a5" />
                          </svg>
                          <h6 className="side-editor-icon">Layout</h6>
                        </Tab>
                        {/*Post Card */}
                        {(currCategory == 'review' ||
                          currCategory == 'social' ||
                          this.props.location.query.wdtnm == 'job_board' ||
                          this.props.location.query.wdtnm == 'tool_team_showcase' ||
                          this.props.location.query.wdtnm == 'tool_youtube_gallery' ||
                          this.props.location.query.wdtnm == 'tool_pricing' ||
                          this.props.location.query.wdtnm == 'tool_number_animation') &&
                          <Tab onClick={() => this.handleTabClick('post_card')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                              <path id="Path_58053" data-name="Path 58053" d="M-524.424,46.3H-529.3a1.285,1.285,0,0,1-1.285-1.285V40.139a1.285,1.285,0,0,1,1.285-1.285h4.872a1.286,1.286,0,0,1,1.285,1.285v4.872A1.286,1.286,0,0,1-524.424,46.3Zm-4.669-5.837v4.232a.117.117,0,0,0,.117.117h4.231a.117.117,0,0,0,.117-.117V40.459a.117.117,0,0,0-.117-.117h-4.232A.117.117,0,0,0-529.093,40.459Zm13.32,5.837h-4.964a1.286,1.286,0,0,1-1.285-1.285V40.139a1.286,1.286,0,0,1,1.285-1.285h4.872a1.286,1.286,0,0,1,1.285,1.285V45.1A1.193,1.193,0,0,1-515.773,46.3Zm-4.762-5.837v4.232a.117.117,0,0,0,.117.117h4.233a.117.117,0,0,0,.117-.117V40.459a.117.117,0,0,0-.117-.117h-4.233A.117.117,0,0,0-520.535,40.459Zm-3.889-2.721H-529.3a1.285,1.285,0,0,1-1.285-1.285V31.581A1.284,1.284,0,0,1-529.3,30.3h4.872a1.285,1.285,0,0,1,1.285,1.285v4.872A1.286,1.286,0,0,1-524.424,37.738Zm-4.669-5.837v4.231a.117.117,0,0,0,.117.117h4.231a.117.117,0,0,0,.117-.117V31.9a.117.117,0,0,0-.117-.117h-4.232A.117.117,0,0,0-529.093,31.9Zm13.227,5.837h-4.872a1.286,1.286,0,0,1-1.285-1.285V31.581a1.285,1.285,0,0,1,1.285-1.285h4.872a1.285,1.285,0,0,1,1.285,1.285v4.872A1.286,1.286,0,0,1-515.866,37.738Zm-4.669-5.837v4.231a.117.117,0,0,0,.117.117h4.233a.117.117,0,0,0,.117-.117V31.9a.117.117,0,0,0-.117-.117h-4.233A.117.117,0,0,0-520.535,31.9Z" transform="translate(530.581 -30.296)" fill="#8392a5" />
                            </svg>
                            <h6 className="side-editor-icon">Cards</h6>
                          </Tab>
                        }
                        {/* Popup */}
                        {(currCategory == 'review' ||
                          currCategory == 'social' ||
                          this.props.location.query.wdtnm == 'job_board' ||
                          this.props.location.query.wdtnm == 'tool_team_showcase' ||
                          this.props.location.query.wdtnm == 'tool_youtube_gallery') && this.state.cnf && this.state.cnf.crdclkact == '2' && this.fnCheckFieldIsDisplayOrNot('cnf.crdclkact', currLayout) &&
                          <Tab onClick={() => this.handleTabClick('popup_card')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15.999" viewBox="0 0 16 15.999">
                              <path id="Path_58055" data-name="Path 58055" d="M-599.683,46.295h-10.371a1.088,1.088,0,0,1-1.087-1.087V42.842h-2.368a1.088,1.088,0,0,1-1.087-1.087V31.384a1.089,1.089,0,0,1,1.087-1.087h10.371a1.089,1.089,0,0,1,1.087,1.087V33.75h2.368a1.089,1.089,0,0,1,1.088,1.087V45.208A1.09,1.09,0,0,1-599.683,46.295Zm-3.974-14.39h-9.33l0,9.33h1.843v-6.4a1.088,1.088,0,0,1,1.087-1.087h6.4Zm3.452,3.453h-9.329v9.33h9.329Z" transform="translate(614.595 -30.296)" fill="#8392a5" opacity="0.998" />
                            </svg>
                            <h6 className="side-editor-icon">Popups</h6>
                          </Tab>
                        }
                        {/* Appearance */}
                        <Tab onClick={() => this.handleTabClick('appearance')}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                            <path id="palette-outline" d="M10,18A8,8,0,1,1,10,2c4.4,0,8,3.2,8,7.2A4.8,4.8,0,0,1,13.2,14H11.76a.378.378,0,0,0-.4.4c0,.08.08.16.08.24A2.172,2.172,0,0,1,11.92,16,1.869,1.869,0,0,1,10,18M10,3.6a6.4,6.4,0,0,0,0,12.8.378.378,0,0,0,.4-.4c0-.16-.08-.24-.08-.32a1.986,1.986,0,0,1,1.52-3.28H13.2a3.2,3.2,0,0,0,3.2-3.2c0-3.12-2.88-5.6-6.4-5.6M5.6,8.4a1.2,1.2,0,0,1,0,2.4,1.2,1.2,0,1,1,0-2.4M8,5.2A1.2,1.2,0,1,1,6.8,6.4,1.23,1.23,0,0,1,8,5.2m4,0a1.2,1.2,0,1,1-1.2,1.2A1.23,1.23,0,0,1,12,5.2m2.4,3.2a1.2,1.2,0,1,1-1.2,1.2A1.23,1.23,0,0,1,14.4,8.4Z" transform="translate(-2 -2)" fill="#8392a5" />
                          </svg>
                          <h6 className="side-editor-icon">Appearance</h6>
                        </Tab>

                        {/* Filter */}
                        {(currCategory == 'review' || currCategory == 'social') && this.state.widgetById && this.state.widgetById.dsi && this.state.widgetById.dsi.length > 0 &&
                          <Tab onClick={() => this.handleTabClick('filter')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 26.5 26.5">
                              <path id="Path_59577" data-name="Path 59577" d="M10.481,26.5a1.248,1.248,0,0,1-1.25-1.25V14.573l-9-12.6A1.25,1.25,0,0,1,1.25,0h24a1.25,1.25,0,0,1,1.017,1.977l-9,12.6v6.985a1.251,1.251,0,0,1-.556,1.04L11.174,26.29a1.244,1.244,0,0,1-.693.21m-6.8-24L11.5,13.446a1.254,1.254,0,0,1,.233.727v8.741l3.037-2.025V14.173A1.246,1.246,0,0,1,15,13.446L22.821,2.5Z" transform="translate(0)" fill="#8392a5" />
                            </svg>
                            <h6 className="side-editor-icon">Filter</h6>
                          </Tab>
                        }
                        {/* Setting */}
                        {(currCategory == 'review' || currCategory == 'social') &&
                          <Tab onClick={() => this.handleTabClick('setting')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                              <g id="Group_9122" data-name="Group 9122" transform="translate(698.599 -58.303)">
                                <path id="Path_19852" data-name="Path 19852" d="M-682.7,65.09a.788.788,0,0,0-.518-.628l-1.19-.423c-.064-.18-.135-.353-.211-.514l.543-1.139a.8.8,0,0,0-.079-.81,8.048,8.048,0,0,0-1.716-1.715.787.787,0,0,0-.81-.077l-1.138.54c-.163-.075-.336-.147-.515-.211l-.423-1.188a.791.791,0,0,0-.626-.518,7.24,7.24,0,0,0-2.431,0,.789.789,0,0,0-.626.518l-.423,1.188c-.17.061-.343.132-.514.211l-1.141-.54a.789.789,0,0,0-.81.076,8.024,8.024,0,0,0-1.715,1.716.791.791,0,0,0-.079.81l.541,1.139c-.075.161-.145.334-.211.514l-1.19.423a.788.788,0,0,0-.517.627,7.772,7.772,0,0,0-.1,1.214,7.745,7.745,0,0,0,.1,1.213.784.784,0,0,0,.517.628l1.19.423c.062.173.133.346.211.514l-.542,1.139a.789.789,0,0,0,.08.81,7.989,7.989,0,0,0,1.715,1.715.785.785,0,0,0,.81.079l1.139-.541c.161.075.334.145.514.211l.423,1.188a.781.781,0,0,0,.626.517,7.883,7.883,0,0,0,1.216.1,7.87,7.87,0,0,0,1.215-.1.789.789,0,0,0,.626-.517l.423-1.188c.173-.062.347-.133.515-.211l1.14.54a.784.784,0,0,0,.81-.076,8.045,8.045,0,0,0,1.715-1.716.792.792,0,0,0,.079-.81l-.542-1.138c.076-.162.148-.336.211-.515l1.191-.423a.789.789,0,0,0,.518-.628,7.811,7.811,0,0,0,.1-1.213A7.822,7.822,0,0,0-682.7,65.09Zm-3.1,2.636a4.953,4.953,0,0,1-.4.967.791.791,0,0,0-.019.72l.5,1.043a6.5,6.5,0,0,1-.725.725l-1.044-.5a.792.792,0,0,0-.719.02,5.135,5.135,0,0,1-.968.4.792.792,0,0,0-.522.495l-.39,1.094a5.031,5.031,0,0,1-1.02,0L-691.5,71.6a.79.79,0,0,0-.521-.495,5.054,5.054,0,0,1-.968-.4.8.8,0,0,0-.721-.02l-1.042.5a6.294,6.294,0,0,1-.725-.725l.495-1.043a.794.794,0,0,0-.018-.72,4.9,4.9,0,0,1-.4-.968.789.789,0,0,0-.495-.522l-1.094-.39a5.031,5.031,0,0,1-.026-.511,5.02,5.02,0,0,1,.026-.509l1.094-.391a.789.789,0,0,0,.495-.522,4.958,4.958,0,0,1,.4-.968.794.794,0,0,0,.018-.72l-.495-1.043a6.3,6.3,0,0,1,.725-.725l1.042.5a.8.8,0,0,0,.721-.02,5.049,5.049,0,0,1,.968-.4.8.8,0,0,0,.522-.495l.39-1.1a5.117,5.117,0,0,1,1.02,0l.39,1.1a.8.8,0,0,0,.522.493,4.991,4.991,0,0,1,.968.4.8.8,0,0,0,.72.02l1.043-.5a6.5,6.5,0,0,1,.725.725l-.5,1.043a.8.8,0,0,0,.02.72,5,5,0,0,1,.4.968.8.8,0,0,0,.5.522l1.094.391c.017.178.025.346.025.51s-.008.331-.025.51l-1.1.39A.8.8,0,0,0-685.8,67.727Z" transform="translate(0 0)" fill="#8392a5" />
                                <path id="Path_19853" data-name="Path 19853" d="M-691.364,62.16a3.248,3.248,0,0,0-3.244,3.245,3.248,3.248,0,0,0,3.244,3.244,3.248,3.248,0,0,0,3.245-3.244A3.248,3.248,0,0,0-691.364,62.16Zm1.66,3.245a1.662,1.662,0,0,1-1.66,1.66,1.661,1.661,0,0,1-1.659-1.66,1.662,1.662,0,0,1,1.659-1.66A1.663,1.663,0,0,1-689.7,65.405Z" transform="translate(0.766 0.74)" fill="#8392a5" />
                              </g>
                            </svg>
                            <h6 className="side-editor-icon">Settings</h6>
                          </Tab>
                        }
                        {/* Setting */}
                        {(currCategory == 'review') && (this.props.location.query.wdtnm !== 'customreview') &&
                          <Tab onClick={() => this.handleTabClick('schema')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
                              <path id="Path_59585" data-name="Path 59585" d="M6.5,8a2.028,2.028,0,1,0,1.406.594A2.02,2.02,0,0,0,6.5,8Zm0,2.5A.5.5,0,1,1,7,10,.481.481,0,0,1,6.5,10.5Zm0-7a6.508,6.508,0,1,0,4.594,1.906A6.455,6.455,0,0,0,6.5,3.5ZM6.5,15a5.015,5.015,0,1,1,3.531-1.469A5.01,5.01,0,0,1,6.5,15ZM5,7.5A.5.5,0,1,0,4.5,7,.481.481,0,0,0,5,7.5Zm-2,1a.5.5,0,0,0,0,1,.5.5,0,0,0,0-1ZM7.5,13a.5.5,0,1,0,.5.5A.481.481,0,0,0,7.5,13Zm2-1a.5.5,0,1,0,.5.5A.481.481,0,0,0,9.5,12Zm0-4.5A.5.5,0,1,0,10,8,.481.481,0,0,0,9.5,7.5ZM4,12a.5.5,0,1,0,.5.5A.481.481,0,0,0,4,12Zm9.562-4.5a6.577,6.577,0,0,1,.344,1.469,2.153,2.153,0,0,0,1.125-.719A1.906,1.906,0,0,0,15.469,7a2.028,2.028,0,0,0-2-2,1.94,1.94,0,0,0-1.125.344,7.408,7.408,0,0,1,.812,1.281A.538.538,0,0,1,13.5,6.5.481.481,0,0,1,14,7,.513.513,0,0,1,13.562,7.5ZM13.5.5a6.258,6.258,0,0,0-2.781.625A6.433,6.433,0,0,0,8.563,2.781a10.739,10.739,0,0,1,1.531.625,1.043,1.043,0,0,1,.344-.437,1.508,1.508,0,0,1,.906-.219,3.364,3.364,0,0,0,.687-.125,2.366,2.366,0,0,0,.563-.281A1.716,1.716,0,0,1,13.469,2a1.746,1.746,0,0,1,.906.344,3.794,3.794,0,0,0,.562.313,6.1,6.1,0,0,0,.688.094,1.508,1.508,0,0,1,.906.219,1.591,1.591,0,0,1,.5.781,2.446,2.446,0,0,0,.312.562,3.212,3.212,0,0,0,.469.438,1.593,1.593,0,0,1,.625.719,1.384,1.384,0,0,1-.062.906A2.165,2.165,0,0,0,18.281,7a2.494,2.494,0,0,0,.094.656,1.449,1.449,0,0,1,.094.875,1.593,1.593,0,0,1-.625.719,3.213,3.213,0,0,0-.469.438,2.446,2.446,0,0,0-.312.563,1.591,1.591,0,0,1-.5.781,1.508,1.508,0,0,1-.906.219,3.364,3.364,0,0,0-.687.125,3.323,3.323,0,0,0-.562.25,2.059,2.059,0,0,1-.687.312,5.7,5.7,0,0,1-.594,1.531.348.348,0,0,0,.156.031H13.5A6.5,6.5,0,0,0,18.094,2.406,6.455,6.455,0,0,0,13.5.5Z" transform="translate(0 -0.5)" fill="#8392a5" />
                            </svg>
                            <h6 className="side-editor-icon">Schema</h6>
                          </Tab>
                        }
                        {/* Display Rule */}
                        {currCategory != 'review' &&
                          currCategory != 'social' &&
                          this.props.location.query.wdtnm !== 'back_to_top' &&
                          this.props.location.query.wdtnm !== 'automation_marketing' &&
                          this.props.location.query.id &&
                          <Tab onClick={() => this.handleTabClick('display_rule')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 10.75 10.75">
                              <g id="Group_8368" data-name="Group 8368" transform="translate(0 0)">
                                <path fill="#c0ccda" id="Path_12846" data-name="Path 12846" d="M5.712,10.75H5.038a.991.991,0,0,1-.99-.99V9.532a4.34,4.34,0,0,1-.674-.28l-.162.162a.99.99,0,0,1-1.4,0l-.477-.477a.99.99,0,0,1,0-1.4L1.5,7.376a4.34,4.34,0,0,1-.28-.674H.99A.991.991,0,0,1,0,5.712V5.038a.991.991,0,0,1,.99-.99h.228a4.341,4.341,0,0,1,.28-.674l-.162-.162a.99.99,0,0,1,0-1.4l.477-.477a.99.99,0,0,1,1.4,0l.162.162a4.344,4.344,0,0,1,.674-.28V.99A.991.991,0,0,1,5.038,0h.675A.991.991,0,0,1,6.7.99v.228a4.34,4.34,0,0,1,.674.28l.162-.162a.99.99,0,0,1,1.4,0l.477.477a.99.99,0,0,1,0,1.4l-.162.162a4.34,4.34,0,0,1,.28.674H9.76a.991.991,0,0,1,.99.99v.675a.991.991,0,0,1-.99.99H9.532a4.341,4.341,0,0,1-.28.674l.162.162a.99.99,0,0,1,0,1.4l-.477.477a.99.99,0,0,1-1.4,0l-.162-.162a4.344,4.344,0,0,1-.674.28V9.76A.991.991,0,0,1,5.712,10.75ZM3.479,8.591a3.712,3.712,0,0,0,.962.4.315.315,0,0,1,.236.3V9.76a.36.36,0,0,0,.36.36h.675a.36.36,0,0,0,.36-.36V9.3a.315.315,0,0,1,.236-.3,3.712,3.712,0,0,0,.962-.4.315.315,0,0,1,.383.048l.329.329a.36.36,0,0,0,.509,0l.477-.477a.36.36,0,0,0,0-.509l-.33-.33a.315.315,0,0,1-.048-.383,3.712,3.712,0,0,0,.4-.962.315.315,0,0,1,.3-.236H9.76a.36.36,0,0,0,.36-.36V5.038a.36.36,0,0,0-.36-.36H9.3a.315.315,0,0,1-.3-.236,3.712,3.712,0,0,0-.4-.962A.315.315,0,0,1,8.639,3.1l.329-.329a.36.36,0,0,0,0-.509l-.477-.477a.36.36,0,0,0-.509,0l-.33.33a.315.315,0,0,1-.383.048,3.712,3.712,0,0,0-.962-.4.315.315,0,0,1-.236-.3V.99a.36.36,0,0,0-.36-.36H5.038a.36.36,0,0,0-.36.36v.465a.315.315,0,0,1-.236.3,3.712,3.712,0,0,0-.962.4A.315.315,0,0,1,3.1,2.111l-.329-.329a.36.36,0,0,0-.509,0l-.477.477a.36.36,0,0,0,0,.509l.33.33a.315.315,0,0,1,.048.383,3.712,3.712,0,0,0-.4.962.315.315,0,0,1-.3.236H.99a.36.36,0,0,0-.36.36v.675a.36.36,0,0,0,.36.36h.465a.315.315,0,0,1,.3.236,3.712,3.712,0,0,0,.4.962.315.315,0,0,1-.048.383l-.329.329a.36.36,0,0,0,0,.509l.477.477a.36.36,0,0,0,.509,0l.33-.33a.316.316,0,0,1,.383-.048Z" />
                                <path fill="#c0ccda" id="Path_12847" data-name="Path 12847" d="M146.939,149.278a2.339,2.339,0,1,1,2.339-2.339A2.342,2.342,0,0,1,146.939,149.278Zm0-4.048a1.709,1.709,0,1,0,1.709,1.709A1.711,1.711,0,0,0,146.939,145.23Z" transform="translate(-141.564 -141.564)" />
                              </g>
                            </svg>
                            <h6 className="side-editor-icon">Display Rule</h6>
                          </Tab>
                        }
                        {/* Data collect */}
                        {currCategory == 'collector' &&
                          <Tab onClick={() => this.handleTabClick('data_collect')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 10.75 10.75">
                              <g id="Group_8368" data-name="Group 8368" transform="translate(0 0)">
                                <path fill="#c0ccda" id="Path_12846" data-name="Path 12846" d="M5.712,10.75H5.038a.991.991,0,0,1-.99-.99V9.532a4.34,4.34,0,0,1-.674-.28l-.162.162a.99.99,0,0,1-1.4,0l-.477-.477a.99.99,0,0,1,0-1.4L1.5,7.376a4.34,4.34,0,0,1-.28-.674H.99A.991.991,0,0,1,0,5.712V5.038a.991.991,0,0,1,.99-.99h.228a4.341,4.341,0,0,1,.28-.674l-.162-.162a.99.99,0,0,1,0-1.4l.477-.477a.99.99,0,0,1,1.4,0l.162.162a4.344,4.344,0,0,1,.674-.28V.99A.991.991,0,0,1,5.038,0h.675A.991.991,0,0,1,6.7.99v.228a4.34,4.34,0,0,1,.674.28l.162-.162a.99.99,0,0,1,1.4,0l.477.477a.99.99,0,0,1,0,1.4l-.162.162a4.34,4.34,0,0,1,.28.674H9.76a.991.991,0,0,1,.99.99v.675a.991.991,0,0,1-.99.99H9.532a4.341,4.341,0,0,1-.28.674l.162.162a.99.99,0,0,1,0,1.4l-.477.477a.99.99,0,0,1-1.4,0l-.162-.162a4.344,4.344,0,0,1-.674.28V9.76A.991.991,0,0,1,5.712,10.75ZM3.479,8.591a3.712,3.712,0,0,0,.962.4.315.315,0,0,1,.236.3V9.76a.36.36,0,0,0,.36.36h.675a.36.36,0,0,0,.36-.36V9.3a.315.315,0,0,1,.236-.3,3.712,3.712,0,0,0,.962-.4.315.315,0,0,1,.383.048l.329.329a.36.36,0,0,0,.509,0l.477-.477a.36.36,0,0,0,0-.509l-.33-.33a.315.315,0,0,1-.048-.383,3.712,3.712,0,0,0,.4-.962.315.315,0,0,1,.3-.236H9.76a.36.36,0,0,0,.36-.36V5.038a.36.36,0,0,0-.36-.36H9.3a.315.315,0,0,1-.3-.236,3.712,3.712,0,0,0-.4-.962A.315.315,0,0,1,8.639,3.1l.329-.329a.36.36,0,0,0,0-.509l-.477-.477a.36.36,0,0,0-.509,0l-.33.33a.315.315,0,0,1-.383.048,3.712,3.712,0,0,0-.962-.4.315.315,0,0,1-.236-.3V.99a.36.36,0,0,0-.36-.36H5.038a.36.36,0,0,0-.36.36v.465a.315.315,0,0,1-.236.3,3.712,3.712,0,0,0-.962.4A.315.315,0,0,1,3.1,2.111l-.329-.329a.36.36,0,0,0-.509,0l-.477.477a.36.36,0,0,0,0,.509l.33.33a.315.315,0,0,1,.048.383,3.712,3.712,0,0,0-.4.962.315.315,0,0,1-.3.236H.99a.36.36,0,0,0-.36.36v.675a.36.36,0,0,0,.36.36h.465a.315.315,0,0,1,.3.236,3.712,3.712,0,0,0,.4.962.315.315,0,0,1-.048.383l-.329.329a.36.36,0,0,0,0,.509l.477.477a.36.36,0,0,0,.509,0l.33-.33a.316.316,0,0,1,.383-.048Z" />
                                <path fill="#c0ccda" id="Path_12847" data-name="Path 12847" d="M146.939,149.278a2.339,2.339,0,1,1,2.339-2.339A2.342,2.342,0,0,1,146.939,149.278Zm0-4.048a1.709,1.709,0,1,0,1.709,1.709A1.711,1.711,0,0,0,146.939,145.23Z" transform="translate(-141.564 -141.564)" />
                              </g>
                            </svg>
                            <h6 className="side-editor-icon">Data collect</h6>
                          </Tab>
                        }
                        {/* Automation Card */}
                        {this.props.location.query.wdtnm === 'automation_marketing' &&
                          <Tab onClick={() => this.handleTabClick('automation')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 10.75 10.75">
                              <g id="Group_8368" data-name="Group 8368" transform="translate(0 0)">
                                <path fill="#c0ccda" id="Path_12846" data-name="Path 12846" d="M5.712,10.75H5.038a.991.991,0,0,1-.99-.99V9.532a4.34,4.34,0,0,1-.674-.28l-.162.162a.99.99,0,0,1-1.4,0l-.477-.477a.99.99,0,0,1,0-1.4L1.5,7.376a4.34,4.34,0,0,1-.28-.674H.99A.991.991,0,0,1,0,5.712V5.038a.991.991,0,0,1,.99-.99h.228a4.341,4.341,0,0,1,.28-.674l-.162-.162a.99.99,0,0,1,0-1.4l.477-.477a.99.99,0,0,1,1.4,0l.162.162a4.344,4.344,0,0,1,.674-.28V.99A.991.991,0,0,1,5.038,0h.675A.991.991,0,0,1,6.7.99v.228a4.34,4.34,0,0,1,.674.28l.162-.162a.99.99,0,0,1,1.4,0l.477.477a.99.99,0,0,1,0,1.4l-.162.162a4.34,4.34,0,0,1,.28.674H9.76a.991.991,0,0,1,.99.99v.675a.991.991,0,0,1-.99.99H9.532a4.341,4.341,0,0,1-.28.674l.162.162a.99.99,0,0,1,0,1.4l-.477.477a.99.99,0,0,1-1.4,0l-.162-.162a4.344,4.344,0,0,1-.674.28V9.76A.991.991,0,0,1,5.712,10.75ZM3.479,8.591a3.712,3.712,0,0,0,.962.4.315.315,0,0,1,.236.3V9.76a.36.36,0,0,0,.36.36h.675a.36.36,0,0,0,.36-.36V9.3a.315.315,0,0,1,.236-.3,3.712,3.712,0,0,0,.962-.4.315.315,0,0,1,.383.048l.329.329a.36.36,0,0,0,.509,0l.477-.477a.36.36,0,0,0,0-.509l-.33-.33a.315.315,0,0,1-.048-.383,3.712,3.712,0,0,0,.4-.962.315.315,0,0,1,.3-.236H9.76a.36.36,0,0,0,.36-.36V5.038a.36.36,0,0,0-.36-.36H9.3a.315.315,0,0,1-.3-.236,3.712,3.712,0,0,0-.4-.962A.315.315,0,0,1,8.639,3.1l.329-.329a.36.36,0,0,0,0-.509l-.477-.477a.36.36,0,0,0-.509,0l-.33.33a.315.315,0,0,1-.383.048,3.712,3.712,0,0,0-.962-.4.315.315,0,0,1-.236-.3V.99a.36.36,0,0,0-.36-.36H5.038a.36.36,0,0,0-.36.36v.465a.315.315,0,0,1-.236.3,3.712,3.712,0,0,0-.962.4A.315.315,0,0,1,3.1,2.111l-.329-.329a.36.36,0,0,0-.509,0l-.477.477a.36.36,0,0,0,0,.509l.33.33a.315.315,0,0,1,.048.383,3.712,3.712,0,0,0-.4.962.315.315,0,0,1-.3.236H.99a.36.36,0,0,0-.36.36v.675a.36.36,0,0,0,.36.36h.465a.315.315,0,0,1,.3.236,3.712,3.712,0,0,0,.4.962.315.315,0,0,1-.048.383l-.329.329a.36.36,0,0,0,0,.509l.477.477a.36.36,0,0,0,.509,0l.33-.33a.316.316,0,0,1,.383-.048Z" />
                                <path fill="#c0ccda" id="Path_12847" data-name="Path 12847" d="M146.939,149.278a2.339,2.339,0,1,1,2.339-2.339A2.342,2.342,0,0,1,146.939,149.278Zm0-4.048a1.709,1.709,0,1,0,1.709,1.709A1.711,1.711,0,0,0,146.939,145.23Z" transform="translate(-141.564 -141.564)" />
                              </g>
                            </svg>
                            <h6 className="side-editor-icon">Automation</h6>
                          </Tab>
                        }

                      </TabList>
                      {/* Data-Set */}
                      {(currCategory == 'review' ||
                        currCategory == 'social' ||
                        this.props.location.query.wdtnm == 'story_widget' ||
                        this.props.location.query.wdtnm == 'job_board' ||
                        this.props.location.query.wdtnm == 'tool_slider' ||
                        this.props.location.query.wdtnm == 'faq' ||
                        this.props.location.query.wdtnm == 'automation_marketing' ||
                        this.props.location.query.wdtnm == 'feedback' ||
                        this.props.location.query.wdtnm == 'tool_restaurant' ||
                        this.props.location.query.wdtnm == 'tool_team_showcase' ||
                        this.props.location.query.wdtnm == 'tool_youtube_gallery' ||
                        this.props.location.query.wdtnm == 'tool_pricing' ||
                        this.props.location.query.wdtnm == 'tool_number_animation')
                        && this.authToken &&
                        <TabPanel>
                          {/* <div className='link-add-integration'>
                          <a className='link-text-brand' onClick={() => this.isOpenIntegrationModel()}>
                            Add Integration
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9">
                              <path id="Path_59543" data-name="Path 59543" d="M-186.373-191.089l.823.773-4.5,4.227-4.5-4.227.823-.773,3.677,3.454.049-.046Z" transform="translate(191.089 -185.55) rotate(-90)" fill="#645cfc" opacity="0.987" />
                            </svg>
                          </a>
                        </div> */}

                          <div className='integration-checkbox-list'>
                            {/* add condition from here */}
                            {
                              localStorage.getItem('userTyp') == 'instafeed' ?
                                <InstaFeedIntegration
                                  createInstaFeedURL={this.createInstaFeedURL}
                                  instaFeedUser={this.props.instaFeedUser}
                                />
                                :
                                <div>
                                  <div className='title-integration'>
                                    Select your data source
                                  </div>
                                  <DatasourceIntegration
                                    lstActiveIntg={this.props.lstActiveIntg}
                                    filterType={this.props.location.query.wdtnm}
                                    arrDataSource={arrDataSource}
                                    handleDataSrc={this.handleDataSource}
                                    viewReviewData={this.viewReviewData}
                                    isOpenIntegrationModel={this.isOpenIntegrationModel}
                                  />
                                </div>
                            }

                          </div>
                          <CustomScrollbars className="editor-side-panel" style={{ display: 'none' }}>
                            {
                              (currCategory == 'review' ||
                                currCategory == 'social' ||
                                this.props.location.query.wdtnm == 'automation_marketing') ?
                                <Tabs className="nf-default-tabs wg-default-editor"
                                  selectedIndex={this.state.intTabIndex}
                                  onSelect={index => this.setIntTabIndex(index)}>
                                  <TabList className="wg-tabs-secstyle wg-tabs-integration">
                                    <div className="sidebar-aniborder-block" id="Wdgt_Intg_sidebar_Blk"></div>
                                    <Tab>Integration</Tab>
                                    <Tab>Active</Tab>
                                  </TabList>
                                  <TabPanel className="tabs-secstyle-panel tabs-panel-dataset  tabs-panel-intagra">
                                    <DatasourceIntegration
                                      lstActiveIntg={this.props.lstActiveIntg}
                                      filterType={this.props.location.query.wdtnm}
                                      arrDataSource={arrDataSource}
                                      handleDataSrc={this.handleDataSource}
                                    />
                                    {/* <Integration
                                    filterType={this.props.location.query.wdtnm}
                                    lstActiveIntg={this.props.lstActiveIntg && this.props.lstActiveIntg}
                                    widgetById={this.state.widgetById ? this.state.widgetById : ''}
                                    queryParam={this.props.location.query}
                                    state={this.state}
                                    allProps={this.props}
                                    fnGetWidgetData={this.fnGetWidgetData}
                                    handleDataSource={this.handleDataSource} /> */}
                                  </TabPanel>
                                  <TabPanel className="tabs-secstyle-panel tabs-panel-dataset tabs-panel-conneted pt-5">
                                    <DataSourceCard
                                      loading={this.props.loading}
                                      widgetById={widgetByIdForInt ? widgetByIdForInt : ''}
                                      state={this.state}
                                      lstActiveIntg={this.props.lstActiveIntg && this.props.lstActiveIntg}
                                      arrDataSource={arrDataSource}
                                      selectDataSrc={this.selectDataSrc}
                                      displayDataSrc={this.displayDataSrc}
                                      handleDataSource={this.handleDataSource}
                                      handleIsLoader={this.handleIsLoader}
                                      widgetType={this.props.location.query.wdtnm} />
                                  </TabPanel>
                                </Tabs>
                                :
                                <StoryWidgetDataCard
                                  cnf={this.state.cnf}
                                  openCloseStoryData={this.state.openCloseStoryData}
                                  openCloseStoryDataPanel={this.openCloseStoryDataPanel}
                                  objStoryData={this.state.objStoryData}
                                  AddfieldinArw={this.AddfieldinArw}
                                  ClonefieldinArw={this.ClonefieldinArw}
                                  handleArrayChange={this.handleArrayChange}
                                  openIconModel={this.openIconModel}
                                  handleAddUpdateWidget={this.handleAddUpdateWidget}
                                  deletefieldinArw={this.deletefieldinArw}
                                  handleEditorFocus={this.handleEditorFocus}
                                  wdtnm={this.props.location.query.wdtnm}
                                  jobSkillChips={this.state.jobSkillChips}
                                  removeChips={this.removeChips}
                                  handleInputchange={this.handleInputchange}
                                  handleEnterEvent={this.handleEnterEvent}
                                  handleArrayDrag={this.handleArrayDrag}
                                  handleChildArrayChange={this.handleChildArrayChange}
                                  AddfieldinChildArw={this.AddfieldinChildArw}
                                  arrName={this.state.arrName}
                                  widgetDataValidator={this.widgetDataValidator} />
                            }
                          </CustomScrollbars>
                        </TabPanel>
                      }
                      {/* Layout Card */}
                      <TabPanel>
                        {
                          currCategory == 'collector' ?
                            <CustomScrollbars className="editor-side-panel">
                              <CollectorLayoutCard
                                cnf={this.state.cnf}
                                handleCnfChange={this.handleCnfChange}
                                handleEditorFocus={this.handleEditorFocus}
                                currLayout={currLayout}
                                arrLylt={this.state.arrLylt}
                                currLayoutId={this.state.currLayoutId}
                                updateLayoutById={this.updateLayoutById}
                                openIconModel={this.openIconModel}
                                fnCheckFieldIsDisplayOrNot={this.fnCheckFieldIsDisplayOrNot}
                                widgetType={this.props.location.query.wdtnm} />
                            </CustomScrollbars>
                            :
                            currCategory == 'tool' &&
                              this.props.location.query.wdtnm !== 'tool_team_showcase' &&
                              this.props.location.query.wdtnm !== 'tool_youtube_gallery' &&
                              this.props.location.query.wdtnm !== 'tool_pricing' &&
                              this.props.location.query.wdtnm !== 'tool_number_animation' ?
                              <CustomScrollbars className="editor-side-panel">
                                <ToolLayoutCard
                                  cnf={this.state.cnf}
                                  handleCnfChange={this.handleCnfChange}
                                  handleEditorFocus={this.handleEditorFocus}
                                  arrLylt={this.state.arrLylt}
                                  currLayoutId={this.state.currLayoutId}
                                  updateLayoutById={this.updateLayoutById}
                                  openIconModel={this.openIconModel}
                                  fnCheckFieldIsDisplayOrNot={this.fnCheckFieldIsDisplayOrNot}
                                  currLayout={currLayout}
                                  widgetType={this.props.location.query.wdtnm} />
                              </CustomScrollbars>
                              :
                              currCategory == 'cta' && this.props.location.query.wdtnm !== 'job_board' ?
                                <CustomScrollbars className="editor-side-panel">
                                  <ChatLayoutCard
                                    cnf={this.state.cnf}
                                    handleCnfChange={this.handleCnfChange}
                                    handleEditorFocus={this.handleEditorFocus}
                                    arrLylt={this.state.arrLylt}
                                    currLayoutId={this.state.currLayoutId}
                                    updateLayoutById={this.updateLayoutById}
                                    handleArrayChange={this.handleArrayChange}
                                    openIconModel={this.openIconModel}
                                    AddfieldinArw={this.AddfieldinArw}
                                    deletefieldinArw={this.deletefieldinArw}
                                    fnCheckFieldIsDisplayOrNot={this.fnCheckFieldIsDisplayOrNot}
                                    currLayout={currLayout}
                                    widgetType={this.props.location.query.wdtnm}
                                  //colorPick={this.state.colorPick}
                                  //handleColorPicker={this.handleColorPicker}
                                  />
                                </CustomScrollbars>
                                :
                                <LayoutCard
                                  cnf={this.state.cnf}
                                  arrLylt={this.state.arrLylt}
                                  currLayoutId={this.state.currLayoutId}
                                  updateLayoutById={this.updateLayoutById}
                                  handleCnfChange={this.handleCnfChange}
                                  handleEditorFocus={this.handleEditorFocus}
                                  handleUpgradePlan={this.handleUpgradePlan}
                                  cn={currCategory}
                                  fnCheckFieldIsDisplayOrNot={this.fnCheckFieldIsDisplayOrNot}
                                  currLayout={currLayout}
                                  widgetType={this.props.location.query.wdtnm} />
                        }
                      </TabPanel>
                      {/* PostCard */}
                      {
                        (currCategory == 'review' ||
                          currCategory == 'social' ||
                          this.props.location.query.wdtnm == 'job_board' ||
                          this.props.location.query.wdtnm == 'tool_team_showcase' ||
                          this.props.location.query.wdtnm == 'tool_youtube_gallery' ||
                          this.props.location.query.wdtnm == 'tool_pricing' ||
                          this.props.location.query.wdtnm == 'tool_number_animation') &&
                        <TabPanel>
                          <CustomScrollbars className="editor-side-panel">
                            <PostCard
                              cnf={this.state.cnf}
                              arrCard={this.state.arrCard}
                              currCardId={this.state.currCardId}
                              handleCnfChange={this.handleCnfChange}
                              updateCardById={this.updateCardById}
                              postCardValidator={this.postCardValidator}
                              currCategory={this.state.currCategory}
                              currLayout={currLayout}
                              fnCheckFieldIsDisplayOrNot={this.fnCheckFieldIsDisplayOrNot}
                              widgetType={this.props.location.query.wdtnm}
                              handleUpgradePlan={this.handleUpgradePlan} />
                          </CustomScrollbars>
                        </TabPanel>
                      }
                      {/* Popup */}
                      {(currCategory == 'review' ||
                        currCategory == 'social' ||
                        this.props.location.query.wdtnm == 'job_board' ||
                        this.props.location.query.wdtnm == 'tool_team_showcase' ||
                        this.props.location.query.wdtnm == 'tool_youtube_gallery') &&
                        this.state.cnf && this.state.cnf.crdclkact == '2' && this.fnCheckFieldIsDisplayOrNot('cnf.crdclkact', currLayout) &&
                        <TabPanel>
                          <CustomScrollbars className="editor-side-panel">
                            <PopupCard
                              cnf={this.state.cnf}
                              currHtnpp={this.state.currHtnpp}
                              popup={this.state.arrPopup}
                              updatePopupById={this.updatePopupById}
                              handleCnfChange={this.handleCnfChange}
                              handleUpgradePlan={this.handleUpgradePlan} />
                          </CustomScrollbars>
                        </TabPanel>
                      }
                      {/* AppearanceCard */}
                      <TabPanel>
                        <CustomScrollbars className="editor-side-panel">
                          {
                            (currCategory == 'review' ||
                              currCategory == 'social' ||
                              this.props.location.query.wdtnm == 'job_board' ||
                              this.props.location.query.wdtnm == 'tool_restaurant' ||
                              this.props.location.query.wdtnm == 'faq' ||
                              this.props.location.query.wdtnm == 'tool_team_showcase' ||
                              this.props.location.query.wdtnm == 'tool_youtube_gallery' ||
                              this.props.location.query.wdtnm == 'tool_pricing' ||
                              this.props.location.query.wdtnm == 'tool_number_animation') ?
                              <AppearanceCard
                                cnf={this.state.cnf}
                                colorPick={this.state.colorPick}
                                handleColorPicker={this.handleColorPicker}
                                handleColorPickerClose={this.handleColorPickerClose}
                                handleCnfChange={this.handleCnfChange}
                                currPopup={currPopup}
                                currCategory={this.state.currCategory}
                                currLayout={currLayout}
                                fnCheckFieldIsDisplayOrNot={this.fnCheckFieldIsDisplayOrNot}
                                wdtnm={this.props.location.query.wdtnm}
                                handleTabchange={this.handleTabchange}
                                currCardId={this.state.currCardId}
                                handleUpgradePlan={this.handleUpgradePlan} />
                              :
                              <ChatAppearanceCard
                                cnf={this.state.cnf}
                                handleCnfChange={this.handleCnfChange}
                                colorPick={this.state.colorPick}
                                handleColorPicker={this.handleColorPicker}
                                currLayout={currLayout}
                                wdtnm={this.props.location.query.wdtnm}
                                fnCheckFieldIsDisplayOrNot={this.fnCheckFieldIsDisplayOrNot} />
                          }
                        </CustomScrollbars>
                      </TabPanel>

                      {/* FilterCard */}
                      {(currCategory == 'review' || currCategory == 'social') && this.state.widgetById && this.state.widgetById.dsi && this.state.widgetById.dsi.length > 0 &&
                        <TabPanel>
                          <CustomScrollbars className="editor-side-panel">
                            <FilterCard
                              widgetById={this.state.widgetById}
                              handleWidgetChange={this.handleWidgetChange}
                              handleInputchange={this.handleInputchange}
                              handleEnterEvent={this.handleEnterEvent}
                              excludeChips={this.state.excludeChips}
                              includeChips={this.state.includeChips}
                              removeChips={this.removeChips}
                              cn={currCategory}
                              handleUpgradePlan={this.handleUpgradePlan} />
                          </CustomScrollbars>
                        </TabPanel>
                      }
                      {/* SettingCard */}
                      {(currCategory == 'review' || currCategory == 'social') &&
                        <TabPanel>
                          <CustomScrollbars className="editor-side-panel">
                            <SettingCard
                              cnf={this.state.cnf}
                              handleCnfChange={this.handleCnfChange}
                              openIconModel={this.openIconModel}
                              handleUpgradePlan={this.handleUpgradePlan} />
                          </CustomScrollbars>
                        </TabPanel>
                      }
                      {(currCategory == 'review') &&
                        <TabPanel>
                          <CustomScrollbars className="editor-side-panel">
                            <SchemaCard
                              state={this.state}
                              widgetById={this.state.widgetById}
                              handleWidgetChange={this.handleWidgetChange}
                              handleSchemaChange={this.handleSchemaChange}
                              handleSchemaStore={this.handleSchemaStore}
                              handleUpgradePlan={this.handleUpgradePlan} />
                          </CustomScrollbars>
                        </TabPanel>
                      }
                      {/* display rules */}
                      {currCategory != 'review' &&
                        currCategory != 'social' &&
                        this.props.location.query.wdtnm !== 'back_to_top' &&
                        this.props.location.query.wdtnm !== 'automation_marketing' &&
                        this.props.location.query.id &&
                        <TabPanel>
                          <CustomScrollbars className="editor-side-panel">
                            <ChatDisplayRuleCard
                              handleCnfChange={this.handleCnfChange}
                              handleChkArray={this.handleChkArray}
                              onChangeUpdateWidget={this.onChangeUpdateWidget}
                              state={this.state}
                              handleInputchange={this.handleInputchange}
                              DisplayValidator={this.DisplayValidator}
                              DisplayUTMValidator={this.DisplayUTMValidator}
                              cookieValidator={this.cookieValidator}
                              ReferralValidator={this.ReferralValidator}
                              removeDisplayRule={this.removeDisplayRule}
                              handleWidgetChange={this.handleWidgetChange}
                              handleTabchange={this.handleTabchange} />
                          </CustomScrollbars>
                        </TabPanel>
                      }
                      {/* Data collect */}
                      {currCategory == 'collector' &&
                        <TabPanel>
                          <DataCollectCard
                            widgetById={this.state.widgetById}
                            handleWidgetChange={this.handleWidgetChange}
                            handleInputchange={this.handleInputchange}
                            frmdtintnm={this.state.frmdtintnm}
                            createCustomCollectorReview={this.createCustomCollectorReview}
                            deleteCustomCollectorReview={this.deleteCustomCollectorReview} />
                        </TabPanel>
                      }
                      {/* Automation Card */}
                      {this.props.location.query.wdtnm === 'automation_marketing' &&
                        <TabPanel>
                          <AutomationCard
                            cnf={this.state.cnf}
                            handleCnfChange={this.handleCnfChange}
                            isPlnPurchase={this.state.isPlnPurchase}
                            openGetCodeModel={this.openGetCodeModel}
                            widgetById={this.state.widgetById}
                            copyWidgetDiv={this.copyWidgetDiv}
                            handleCancelSchedule={this.handleCancelSchedule} />
                        </TabPanel>
                      }
                    </Tabs>
                    {/* <div className="getcode-sidebar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30.671 24.384">
                      <g id="Group_8466" data-name="Group 8466" transform="translate(0 -52.478)">
                        <path id="Path_14190" data-name="Path 14190" d="M364.278,119.237l-7.093-7.514a1.15,1.15,0,1,0-1.673,1.579l6.348,6.725-6.348,6.725a1.15,1.15,0,0,0,1.673,1.58l7.093-7.515A1.151,1.151,0,0,0,364.278,119.237Z" transform="translate(-333.92 -55.356)" />
                        <path id="Path_14191" data-name="Path 14191" d="M9.08,126.749l-6.347-6.725L9.08,113.3a1.15,1.15,0,0,0-1.673-1.579L.314,119.235a1.151,1.151,0,0,0,0,1.579l7.093,7.515a1.15,1.15,0,0,0,1.673-1.58Z" transform="translate(0 -55.355)" />
                        <path id="Path_14192" data-name="Path 14192" d="M213.335,52.491a1.151,1.151,0,0,0-1.311.963L208.65,75.538a1.15,1.15,0,0,0,.963,1.311,1.184,1.184,0,0,0,.175.013,1.15,1.15,0,0,0,1.136-.977L214.3,53.8A1.15,1.15,0,0,0,213.335,52.491Z" transform="translate(-196.138)" />
                      </g>
                    </svg>
                  </div> */}
                  </aside>
                  {/* Preview card */}
                  <PreviewCard
                    //cnf={this.state.cnf}
                    //wid={this.props.location.query.id}
                    currLayout={currLayout}
                    currCard={currCard}
                    currPopup={currPopup}
                    lstWidgetData={this.props.lstWidgetData}
                    isMobileScreen={this.state.isMobileScreen}
                    singleField={this.props.themeData && this.props.themeData.singleField}
                    widgetById={this.state.widgetById}
                    wdtnm={this.props.location.query.wdtnm}
                    cn={currCategory} />
                </div>
                :
                <ContentLoader
                  height={920}
                  width={430}
                  speed={2}
                  primaryColor="#fff"
                  secondaryColor="#eceef4">
                  <rect x="0" y="0" rx="0" ry="0" width="15" height="225" />
                  <rect x="18" y="0" rx="0" ry="0" width="75" height="225" />
                </ContentLoader>
              }
            </div>
            :
            this.props.location.query.ds == 'type' ?
              <CreateWidgetCard
                themeData={this.props.themeData}
                widgetList={this.state.widgetList}
                newWidget={this.state.newWidget}
                filterWidgetList={this.filterWidgetList}
                searchWidgetHandle={this.searchWidgetHandle}
                rdtEditWidget={this.rdtEditWidget}
                loading={this.props.loading}
                openPlanModel={this.openPlanModel}
                handleCreateWidgetTabChange={this.handleCreateWidgetTabChange}
                createWidgetIndex={this.state.createWidgetIndex}
                state={this.state}
                handleWidgetTabClick={this.handleWidgetTabClick}
                dmyWdIndex={this.state.dmyWdIndex} />
              :
              localStorage.getItem('pvd') == 'shopify' ?
                <ShopifyWidgetList
                  userWidget={this.state.widgetListByUser}
                  editWidget={this.editWidget}
                  currWidgetMst={this.state.currWidgetMst}
                  rdtEditWidget={this.rdtEditWidget}
                  deleteWidget={this.deleteWidget}
                  openCloseHireusModel={this.openCloseHireusModel}
                  changeWidgetStatus={this.changeWidgetStatus}
                  openGetCodeModel={this.openGetCodeModel}
                  handelWidgetNameEdit={this.handelWidgetNameEdit}
                  handleWidgetNameSave={this.handleWidgetNameSave}
                  handelwidgetNameClose={this.handelwidgetNameClose}
                  //getAnalytic={this.getAnalytic}
                  getLatestQuotaUses={this.getLatestQuotaUses}
                  state={this.state} />
                :
                <div className='wdgt-dashborad-content'>
                  <WidgetList
                    themeData={this.props.themeData}
                    openCloseWidgetPanel={this.openCloseWidgetPanel}
                    state={this.state}
                    userWidgetList={userWidgetList}
                    changeWidgetStatus={this.changeWidgetStatus}
                    editWidget={this.editWidget}
                    copyWidgetDiv={this.copyWidgetDiv}
                    deleteWidget={this.deleteWidget}
                    widgetListfilterByUser={this.widgetListfilterByUser}
                    openCloseAnalyticModel={this.openCloseAnalyticModel}
                    openCloseHireusModel={this.openCloseHireusModel}
                    loading={this.props.loading}
                    handelWidgetNameEdit={this.handelWidgetNameEdit}
                    handleWidgetNameSave={this.handleWidgetNameSave}
                    handelwidgetNameClose={this.handelwidgetNameClose}
                    rdtEditWidget={this.rdtEditWidget}
                    openGetCodeModel={this.openGetCodeModel}
                    openCloneThemeModal={this.openCloneThemeModal}
                    rdtCreateWidget={this.rdtCreateWidget}
                    getLatestQuotaUses={this.getLatestQuotaUses}
                    handleWidgetTabClick={this.handleWidgetTabClick}
                    handleWidgetListTabChange={this.handleWidgetListTabChange}
                    WidgetListIndex={this.state.WidgetListIndex}
                    profile={this.props.profile} />
                </div>
        }
        <Modal
          id='HireusModel'
          className='HireusModel'
          title='Hire us'
          content={this.hireusModelCont()}
          openCloseModal={this.openCloseHireusModel}
          style={
            {
              modalStyle: {
                display: this.state.isOpenHireusModel ? 'block' : 'none',
                opacity: this.state.isOpenHireusModel ? 1 : 0
              },
              alignModalStyle: {
                top: '210px'
              }
            }
          } />

        <Modal
          id='cloneModal'
          className='cloneModal'
          title={'Make a clone of ' + this.state.cloneWn}
          content={this.cloneThemeModelCont()}
          openCloseModal={this.closeCloneThemeModal}
          style={
            {
              modalStyle: {
                display: this.state.openCloseCloneModal ? 'block' : 'none',
                opacity: this.state.openCloseCloneModal ? 1 : 0
              },
              alignModalStyle: {
                top: '210px'
              }
            }
          } />

        <Modal
          id='GetCodeModel'
          className={this.state.isPlnPurchase == false ? 'GetCodeModel modal-hdrnone' : 'GetCodeModel modal-hdrnone'}//'GetCodeModel modal-hdrnone'
          title=''
          content={this.getCodeModelCont()}
          openCloseModal={this.closeGetCodeModel}
          style={
            {
              modalStyle: {
                display: this.state.isOpenGetCodeModel ? 'block' : 'none',
                opacity: this.state.isOpenGetCodeModel ? 1 : 0
              },
              alignModalStyle: {
                top: '200px'
              }
            }
          } />
        <div className='panel-sltdata-wrap'>
          <SlidingPanel
            type={'left'}
            isOpen={this.state.isOpenIntegrationModel}
            size={'24'}
            className={'sdasd'}
            panelClassName='panel-content-integration'
            backdropClicked={this.isOpenIntegrationModel}>
            <div className="intrag-review-wrap side-panel-integralist ">
              <Integration
                filterType={this.props.location.query.wdtnm}
                lstActiveIntg={this.props.lstActiveIntg && this.props.lstActiveIntg}
                widgetById={this.state.widgetById ? this.state.widgetById : ''}
                queryParam={this.props.location.query}
                isOpenIntegrationModel={this.isOpenIntegrationModel}
                state={this.state}
                viewReviewData={this.viewReviewData}
                allProps={this.props}
                fnGetWidgetData={this.fnGetWidgetData}
                handleDataSource={this.handleDataSource} />
            </div>
          </SlidingPanel>
        </div>
        {/* <SlidingPanel
          type={'left'}
          isOpen={this.state.isOpenViewReviewModel}
          size={24}
          panelClassName='panel-content-integration'
        // backdropClicked={this.viewReviewData}
        >
          <Review
            viewReviewData={this.viewReviewData}
            fnGetWidgetData={this.fnGetWidgetData}
            state={this.state}
            allProps={this.props} />
        </SlidingPanel> */}
        {/* <Modal
          id='planInfoPlan'
          className='GetCodeModel modal-hdrnone'
          title=''
          content={this.displayPlanInfo()}
          openCloseModal={this.closePlanInfoModel}
          style={
            {
              modalStyle: {
                display: this.state.isOpenPlanModel ? 'block' : 'none',
                opacity: this.state.isOpenPlanModel ? 1 : 0
              },
              alignModalStyle: {
                top: '300px'
              }
            }
          } /> */}

        <Modal
          id='iconModel'
          className='iconModel'
          title='Upload icon'
          content={this.iconModelCont()}
          openCloseModal={this.closeIconModel}
          style={
            {
              modalStyle: {
                display: this.state.openCloseIconModel ? 'block' : 'none',
                opacity: this.state.openCloseIconModel ? 1 : 0
              },
              alignModalStyle: {
                top: '210px'
              }
            }
          } />

        <Modal
          id='analyticModel'
          className='analyticModel'
          //title='Widget Analytic'
          content={this.analyticModelCont()}
          openCloseModal={this.openCloseAnalyticModel}
          style={
            {
              modalStyle: {
                display: this.state.isOpenAnalyticModel ? 'block' : 'none',
                opacity: this.state.isOpenAnalyticModel ? 1 : 0
              },
              alignModalStyle: {
                top: '210px'
              }
            }
          } />

        <Modal
          id='instafeed_intro'
          className='instafeedModel'
          title=''
          content={this.instaFeedModel()}
          openCloseModal={this.openCloseInstaFeedModel}
          style={
            {
              modalStyle: {
                display: this.state.isOpenInstaFeedModel ? 'block' : 'none',
                opacity: this.state.isOpenInstaFeedModel ? 1 : 0
              },
              alignModalStyle: {
                top: '210px'
              }
            }
          } />
      </div >
    );
  }
}

const mapStateToProps = state => ({
  themeData: state.getIn(['master', 'themeData']),
  loading: state.getIn(['loading', 'state']),
  profile: state.getIn(['auth', 'profile']),
  userWidget: state.getIn(['widget', 'userWidget']),
  widgetById: state.getIn(['widget', 'widgetById']),
  iconList: state.getIn(['widget', 'iconList']),
  lstActiveIntg: state.getIn(['widget', 'lstActiveIntg']),
  lstWidgetData: state.getIn(['widget', 'lstWidgetData']),
  //dataCount: state.getIn(['wall', 'dataCount']),
  //intData: state.getIn(['wall', 'intData']),
  analytic: state.getIn(['widget', 'analytic']),
  widgetList: state.getIn(['integration', 'widgetList']),
  lstWidgetDiv: state.getIn(['widget', 'lstWidgetDiv']),
  lstUsrInt: state.getIn(['integration', 'lstUsrInt']),
  activeStatus: state.getIn(['widget', 'activeStatus']),
  instaFeedURL: state.getIn(['instaFeed', 'instaFeedURL']),
  instaFeedUser: state.getIn(['instaFeed', 'instaFeedUser']),
});

const mapDispatchToProps = {
  createWidget,
  getWidgetByUser,
  getWidgetById,
  getWidgetData,
  getThemeData,
  getActiveIntgList,
  addDataSrc,
  delDataSrc,
  updWidgetCnf,
  updWidgetStatus,
  delUserWidget,
  getAnalytic,
  createHireUs,
  updWidgetName,
  getWidgetForInt,
  redisCreateWidget,
  createCloneWidget,
  addShpWidgetDiv,
  getShpThemeList,
  deleteShpWidgetDiv,
  getProfile,
  updWidgetIcon,
  getIconList,
  deleteIcon,
  onChangeUpdateWidget,
  createCustomCollectorReview,
  deleteCustomCollectorReview,
  onChangeSaveFilter,
  updSchemaValue,
  createInstaFeedURL,
  instaFeedPaymant
  //getUsrIntegration
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Widget);


// WEBPACK FOOTER //
// ./src/containers/Widget/Widget.js